import type { Translations } from './types';

const pt: Translations = {
  nav: {
    approvals: 'Aprovações',
    home: 'Início',
    search: 'Pesquisar',
    dashboard: 'Painel',
    outdoors: 'Outdoors',
    campaigns: 'Campanhas',
    admin: 'Admin',
    logIn: 'Entrar',
    signUp: 'Registar',
    logOut: 'Sair',
    account: 'Conta',
    setupBusiness: 'Configurar Empresa',
    searchOutdoors: 'Pesquisar Outdoors',
    manageOutdoors: 'Gerir Outdoors',
    verifyOutdoors: 'Verificar Outdoors',
    adminPanel: 'Painel de Administração',
    upcomingCampaigns: 'Próximas Campanhas',
    getPaid: 'Receber Pagamento',
    revenue: 'Receita',
    payments: 'Pagamentos',
  },
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    back: 'Voltar',
    next: 'Seguinte',
    done: 'Concluído',
    loading: 'A carregar…',
    error: 'Algo correu mal',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    clear: 'Limpar',
    edit: 'Editar',
    add: 'Adicionar',
    search: 'Pesquisar',
    view: 'Ver',
    create: 'Criar',
    update: 'Atualizar',
    submit: 'Enviar',
    yes: 'Sim',
    no: 'Não',
    close: 'Fechar',
    upload: 'Carregar',
    uploading: 'A carregar…',
    saving: 'A guardar…',
    creating: 'A criar…',
    noResults: 'Sem resultados',
    required: 'Obrigatório',
    optional: 'Opcional',
    copy: 'Copiar',
    copied: 'Copiado!',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    page: 'Página',
    of: 'de',
    perDay: '/dia',
    days: '{{count}} dia',
    days_plural: '{{count}} dias',
    termsAndConditions: 'Termos e Condições',
    selectCountry: 'Selecione um país...',
    noCountriesFound: 'Nenhum país encontrado',
    notSet: 'Não definido',
    showPassword: 'Mostrar palavra-passe',
    hidePassword: 'Ocultar palavra-passe',
    refresh: 'Atualizar',
    new: 'Novo',
    rowsPerPage: 'Linhas por página',
  },
  home: {
    tagline: 'A plataforma de OOH estática orientada para a visibilidade e estratégia',
    heroTitle: 'Dê à sua marca novas alturas',
    heroSubtitle:
      'A Scapow liga proprietários de outdoors a anunciantes. Explore espaços reais, planeie campanhas e alcance o seu público - tudo numa só platforma.',
    browseOutdoors: 'Explorar Outdoors',
    getStartedFree: 'Começar Gratuitamente',
    featuredOutdoors: 'Outdoors em Destaque',
    viewAll: 'Ver todos →',
    howItWorksTitle: 'Como funciona',
    howItWorksSubtitle: 'Três passos simples para colocar a sua mensagem à frente do público certo.',
    step1Title: 'Encontre o espaço ideal',
    step1Desc:
      'Pesquise outdoors por localização, tamanho e preço. Filtre pela disponibilidade nas suas datas.',
    step2Title: 'Crie a sua campanha',
    step2Desc:
      'Adicione vários outdoors a uma campanha, carregue os seus criativos e obtenha os detalhes de pagamento.',
    step3Title: 'Acompanhe os resultados',
    step3Desc:
      'Monitorize o progresso da campanha, o estado dos banners e as métricas de desempenho no seu painel.',
    builtTitle: 'Feito para ambos os lados',
    builtSubtitle:
      'Seja proprietário de outdoors ou anunciante, a Scapow tem o que precisa.',
    feature1Title: 'Liste os seus outdoors',
    feature1Desc:
      'Liste facilmente os seus outdoors, defina preços, adicione fotos e controle a disponibilidade.',
    feature2Title: 'Pesquisa no mapa',
    feature2Desc:
      'Encontre outdoors num mapa em tempo real. Aproxime para um raio menor, afaste para maior alcance.',
    feature3Title: 'Gestão de campanhas',
    feature3Desc:
      'Crie campanhas com vários outdoors, carregue criativos e pague por transferência bancária.',
    feature4Title: 'Empresas verificadas',
    feature4Desc: 'Todas as empresas são verificadas com documentos antes de publicar.',
    feature5Title: 'Monitorização de desempenho',
    feature5Desc:
      'Anunciantes e fornecedores obtêm visões gerais de receitas e atividade no painel.',
    feature6Title: 'Preços transparentes',
    feature6Desc: 'Tarifas do fornecedor exibidas por dia - sempre visíveis antes de confirmar.',
    ctaTitle: 'Pronto para começar?',
    ctaSubtitle: 'Junte-se à Scapow hoje e comece a ligar-se ao mercado de publicidade exterior.',
    createAccount: 'Criar Conta',
    browseFirst: 'Explorar Primeiro',
    nearbyOutdoors: 'Outdoors Perto de Si',
    detectingLocation: 'A detetar a sua localização…',
    basedOnLocation: 'Baseado na sua localização atual',
    welcomeBack: 'Bem-vindo, {{name}}',
    fromCompany: 'da {{company}}',
    ppPrompt: 'Todos os seus outdoors estão prontos para novas Campanhas?',
    advertiserPrompt: 'Está pronto para criar algumas Campanhas?',
    noCompanyPrompt: 'Configure a sua empresa para desbloquear todas as funcionalidades.',
    goToDashboard: 'Ir para o Painel',
    inviteFrom: '{{company}} convidou-o(a) a juntar-se à sua equipa na Scapow.',
    inviteFromDesc: 'Aceite para começar a colaborar em campanhas de publicidade exterior.',
    inviteAccept: 'Aceitar Convite',
    inviteDecline: 'Recusar',
    inviteAccepted: 'Bem-vindo(a) a bordo! Juntou-se com sucesso à {{company}}.',
    inviteDeclined: 'Declinou o convite.',
    ppHowItWorksSubtitle: 'Tudo o que precisa para transformar os seus espaços outdoor numa fonte de receita constante.',
    ppStep1Title: 'Destaque os seus espaços',
    ppStep1Desc: 'Liste os seus outdoors com fotos apelativas, dimensões exatas e preços competitivos - para que os anunciantes reconheçam o valor ao primeiro olhar.',
    ppStep2Title: 'Seja encontrado pelas marcas',
    ppStep2Desc: 'Os seus outdoors aparecem nas pesquisas de anunciantes a planear a próxima campanha. A campanha certa encontra-o a si.',
    ppStep3Title: 'Prove e receba',
    ppStep3Desc: 'Envie comprovativos fotográficos assim que o outdoor estiver montado e em funcionamento. O pagamento é processado automaticamente após aprovação.',
  },
  auth: {
    login: {
      heroTitle: 'Ligue a sua marca ao mundo. Uma nova altura de cada vez.',
      heroSubtitle:
        'A plataforma que une proprietários de outdoors a anunciantes - simples, rápida e impactante.',
      title: 'Bem-vindo de volta',
      subtitle: 'Inicie sessão para continuar',
      email: 'Endereço de email',
      password: 'Palavra-passe',
      forgotPassword: 'Esqueceu a palavra-passe?',
      resendVerification: 'Reenviar email de verificação',
      signIn: 'Entrar',
      noAccount: 'Não tem conta?',
      createOne: 'Crie uma',
      invalidCredentials: 'Email ou palavra-passe inválidos. Tente novamente.',
    },
    register: {
      heroTitle: 'Junte-se à revolução da publicidade exterior',
      heroSubtitle:
        'Seja proprietário de outdoors ou anunciante, a Scapow torna tudo mais fácil.',
      title: 'Crie a sua conta',
      subtitle: 'Comece a gerir campanhas de publicidade exterior hoje',
      firstName: 'Nome próprio',
      lastName: 'Apelido',
      email: 'Endereço de email',
      password: 'Palavra-passe',
      confirmPassword: 'Confirmar palavra-passe',
      passwordHint: 'Mínimo 8 caracteres',
      createAccount: 'Criar conta',
      alreadyHaveAccount: 'Já tem conta?',
      signIn: 'Iniciar sessão',
      checkEmail: 'Verifique o seu email',
      checkEmailDesc:
        'Enviámos um link de verificação para o seu endereço de email. Clique nele para ativar a conta.',
      goToLogin: 'Ir para o login',
      termsAgreement: 'Li e concordo com os',
      termsLink: 'Termos e Condições',
    },
    forgotPassword: {
      title: 'Recuperar palavra-passe',
      subtitle: 'Insira o seu email e enviaremos um link de recuperação',
      email: 'Endereço de email',
      sendReset: 'Enviar link de recuperação',
      backToLogin: 'Voltar ao login',
      checkEmail: 'Verifique o seu email',
      checkEmailDesc:
        'Se esse endereço estiver registado, receberá um link de recuperação em breve.',
    },
    resetPassword: {
      title: 'Definir nova palavra-passe',
      subtitle: 'Escolha uma palavra-passe forte de que se lembre.',
      newPassword: 'Nova palavra-passe',
      confirmPassword: 'Confirmar palavra-passe',
      save: 'Guardar nova palavra-passe',
      submit: 'Atualizar palavra-passe',
    },
    verifyEmail: {
      verifying: 'A verificar o seu email…',
      success: 'Email verificado!',
      successDesc: 'A sua conta está ativa. Pode iniciar sessão.',
      error: 'Verificação falhou',
      errorDesc: 'O link pode estar expirado ou inválido. Por favor registe-se novamente.',
      goToLogin: 'Ir para o login',
      successDescBusiness: 'A sua conta está ativa. Pode iniciar sessão e configurar a sua empresa.',
      returnToLogin: 'Voltar ao login',
      resendButton: 'Solicitar novo link de verificação',
    },
    resendVerification: {
      title: 'Reenviar email de verificação',
      subtitle: 'Insira o seu email e enviaremos um novo link de verificação.',
      email: 'Endereço de email',
      send: 'Enviar email de verificação',
      backToLogin: 'Voltar ao login',
      checkEmail: 'Verifique o seu email',
      checkEmailDesc: 'Se a sua conta estiver a aguardar verificação, enviámos um novo link para a sua caixa de entrada.',
    },
  },
  business: {
    pendingVerification: 'A sua conta empresarial está atualmente em processo de validação. Assim que a nossa equipa concluir a verificação, terá acesso completo a todas as funcionalidades da Scapow. Entretanto, fique atento ao seu email - poderemos contactá-lo caso seja necessária documentação adicional.',
    setup: {
      title: 'Configure a sua Empresa',
      subtitle: 'Associe a sua conta a uma entidade empresarial para começar a usar a Scapow.',
      ppTitle: 'Fornecedor de Espaços',
      ppDesc: 'Tenho espaços de publicidade exterior e quero alugá-los.',
      advertiserTitle: 'Anunciante',
      advertiserDesc: 'Quero reservar campanhas de publicidade exterior.',
      changeType: 'Alterar ↩',
      createCompany: 'Criar nova empresa',
      createCompanyDesc: 'Registe a sua empresa na Scapow.',
      joinCompany: 'Juntar-se a empresa existente',
      joinCompanyDesc: 'Solicite acesso a uma empresa já registada.',
      registerTitle: 'Registar a sua empresa',
      companyName: 'Nome da empresa',
      vatNumber: 'Número de contribuinte',
      companyEmail: 'Email da empresa',
      currency: 'Moeda preferida',
      currencyHint: 'Código ISO de moeda, ex: EUR, USD, GBP',
      country: 'País',
      proofDocument: 'Documento de comprovativo empresarial',
      proofHint: 'PDF, JPG ou PNG',
      uploadProof: 'Clique para carregar comprovativo da empresa',
      createCompanyBtn: 'Criar empresa',
      bankTitle: 'Dados bancários',
      bankSubtitlePP: 'O seu IBAN e SWIFT/BIC serão utilizados para os pagamentos quando as suas campanhas de exterior estiverem ativas.',
      bankSubtitleAdvertiser: 'O seu IBAN e SWIFT/BIC serão utilizados para processar reembolsos, se aplicável.',
      findTitle: 'Encontrar a sua empresa',
      searchPlaceholder: 'Pesquisar por nome da empresa…',
      noCompanies: 'Nenhuma empresa encontrada. Pesquise pelo nome.',
      requestAccess: 'Solicitar acesso',
      requested: 'Solicitado',
      accessSentMsg:
        'Pedido de acesso enviado! Um administrador da empresa precisa de o aprovar. Será notificado quando aprovado.',
      pendingTitle: 'Pedido de Acesso Pendente',
      pendingDesc: 'O seu pedido para entrar em {{name}} está a ser analisado. Será notificado quando aprovado.',
      cancelRequest: 'Cancelar Pedido',
      requestCancelled: 'Pedido de acesso cancelado.',
      connectingToEntity: 'A ligar à sua organização…',
      accessApproved: 'O seu pedido de acesso foi aprovado! Já faz parte da equipa.',
      accessRejected: 'O seu pedido de acesso foi rejeitado. Por favor, crie ou junte-se a outra entidade empresarial.',
      orSetupYourOwn: 'Em alternativa, registe a sua empresa ou junte-se a uma já existente.',
      invitationsTitle: 'Convites Pendentes',
      invitationsSubtitle: 'Foi convidado para se juntar a uma empresa. Aceite ou recuse o convite abaixo.',
      invitedOn: 'Convidado em',
      acceptInvitation: 'Aceitar',
      declineInvitation: 'Recusar',
      invitationAccepted: 'Convite aceite! A ligar à sua organização…',
      invitationDeclined: 'Convite recusado.',
    },
    details: {
      title: 'Detalhes da Empresa',
      subtitle: 'Consulte e atualize o registo e os dados bancários da sua empresa.',
      registrationTitle: 'Detalhes de registo',
      companyName: 'Nome da empresa',
      vatNumber: 'Número de contribuinte',
      companyEmail: 'Email da empresa',
      currency: 'Moeda preferida',
      country: 'País',
      portugueseRegion: 'Região Portuguesa',
      regionContinent: 'Continente',
      regionAzores: 'Açores',
      regionMadeira: 'Madeira',
      replaceProof: 'Substituir documento de comprovativo',
      uploadProof: 'Clique para carregar um novo documento de comprovativo',
      saveChanges: 'Guardar alterações',
      addressSectionTitle: 'Morada',
      addressLine: 'Morada',
      addressLinePlaceholder: 'Rua Principal 123',
      city: 'Cidade',
      postCode: 'Código postal',
      state: 'Estado',
      stateHint: 'Obrigatório para contas de pagamento em USD',
      selectState: 'Selecione um estado',
      bankTitle: 'Detalhes bancários',
      bankSubtitle: 'Utilizado para receber pagamentos dos anunciantes.',
      bankSubtitlePP: 'O seu IBAN e SWIFT/BIC são utilizados para pagamentos quando as campanhas ficam ativas.',
      bankSubtitleAdvertiser: 'O seu IBAN e SWIFT/BIC são utilizados para reembolsos, quando aplicável.',
      bankClickUnlock: 'Bloqueado - clique para editar',
      iban: 'IBAN',
      swift: 'SWIFT / BIC',
      ibanHint: 'Número de Conta Bancária Internacional...',
      swiftHint: '8 ou 11 caracteres: código do banco (4) + país (2) + localização (2) + sucursal opcional (3)',
      accountNumber: 'Número de conta',
      accountNumberHint: 'O seu número de conta bancária de USD (4–17 dígitos)',
      saveBankDetails: 'Guardar dados bancários',
      verifiedLocked: 'O nome da empresa, o NIF e o país estão bloqueados após a verificação.',
      verifiedBadge: 'Verificado',
      pendingReviewTitle: 'A Aguardar Aprovação',
      pendingReviewDesc: 'O seu registo empresarial está em análise. Terá acesso completo à plataforma assim que a nossa equipa o aprovar - iremos notificá-lo em tempo real.',
      verifiedTitle: 'Identidade Verificada',
      verifiedDesc: 'A identidade da sua empresa foi confirmada. Não é necessária qualquer documentação adicional.',
      proofCardTitle: 'Documento de Verificação',
      proofCardDesc: 'Carregue o documento de registo da sua empresa para apoiar a verificação da sua conta. A nossa equipa irá analisá-lo e contactá-lo caso seja necessário algo mais.',
      proofCardSubmit: 'Submeter para Revisão',
      proofCardSuccess: 'Documento submetido com sucesso. A nossa equipa irá analisá-lo e entrar em contacto se necessário.',
      proofCardValidatingTitle: 'Documentos em Análise',
      proofCardValidatingDesc: 'Os seus documentos de verificação foram recebidos e estão a ser analisados pela nossa equipa. Será notificado assim que o processo estiver concluído.',
      proofCardProcessingTitle: 'A processar o ficheiro',
      proofCardProcessingDesc: 'Recebemos o seu documento e estamos a verificá-lo automaticamente. Não vai demorar muito.',
      proofCardReplaceFile: 'Submeteu o ficheiro errado? Substitua-o',
    },
  },
  search: {
    instantBookingHint: 'Confirmação imediata, sem aguardar a aprovação do fornecedor',
    priceFilterLocked: 'Os filtros de preço ficam disponíveis depois de iniciar sessão e estar associado a uma entidade empresarial.',
    title: 'Pesquisar Outdoors',
    subtitle: 'Encontre espaços de outdoor no mapa',
    filters: 'Filtros',
    minWidth: 'Largura mínima (m)',
    maxWidth: 'Largura máxima (m)',
    minHeight: 'Altura mínima (m)',
    maxHeight: 'Altura máxima (m)',
    minPrice: 'Preço mínimo (€/dia)',
    maxPrice: 'Preço máximo (€/dia)',
    providerName: 'Nome do fornecedor',
    clearFilters: 'Limpar filtros',
    noResults: 'Nenhum outdoor encontrado nesta área',
    noResultsDesc: 'Tente ampliar a área no mapa, refinar os filtros ou aumentar a duração da campanha para expandir a disponibilidade.',
    addToCart: 'Adicionar ao carrinho',
    inCart: 'No carrinho',
    selectDates: 'Selecionar datas',
    from: 'De',
    to: 'Até',
    results: 'resultados',
    loading: 'A carregar outdoors…',
    resultsTab: 'Resultados ({{count}})',
    mapTab: 'Mapa',
    searching: 'A pesquisar…',
    found: '{{count}} outdoor encontrado',
    found_plural: '{{count}} outdoors encontrados',
    moveMap: 'Mova o mapa para atualizar os resultados',
    noticePeriodHint: 'Alguns fornecedores de espaço exigem um período mínimo de aviso prévio antes de uma campanha poder começar, ou um período mínimo de arrendamento, o que pode afetar a disponibilidade e os resultados de pesquisa.',
    noOutdoorsFound: 'Nenhum espaço publicitário encontrado',
    noOutdoorsFoundAdjustDates: 'Tente ajustar as suas datas de início e fim, ou afaste o zoom.',
    noOutdoorsFoundAdjustFilters: 'Afaste o zoom ou ajuste os seus filtros.',
    inCampaign: 'Na campanha',
    attributes: 'Localizado perto de',
    withDiscounts: 'Descontos por volume disponíveis',
    illuminated: 'Apenas iluminados',
    illuminatedHint: 'outdoor tem iluminação (ex: durante a noite)',
    containsDiscounts: 'Descontos por volume',
    containsDiscountsDesc: 'Este outdoor oferece preços escalonados - quanto mais dias reservar, menor a tarifa diária.',
  },
  outdoor: {
    startAtMonthFirstDay: 'Começar no dia 1 do mês',
    startAtMonthFirstDayHint: 'As reservas têm de começar no dia 1 de um mês. Com apenas meses completos, são feitas por meses de calendário completos (do dia 1 ao último dia).',
    acceptingToastOn: '{{name}} está agora a aceitar novas campanhas.',
    acceptingToastOff: '{{name}} está em pausa - oculto da pesquisa e fechado a novas reservas.',
    acceptingToastBulkOn: '{{count}} outdoor(s) a aceitar novas campanhas.',
    acceptingToastBulkOff: '{{count}} outdoor(s) em pausa - ocultos da pesquisa e fechados a novas reservas.',
    fullMonthRequired: 'Apenas meses completos',
    fullMonthRequiredHint: 'Os anunciantes reservam ao mês: do dia de início até ao mesmo dia do mês seguinte (começando no dia 1, até ao último dia do mês), durante quantos meses consecutivos quiserem.',
    fullMonthTooltip: 'Reservado ao mês - do dia de início até ao mesmo dia de um mês seguinte.',
    stepsTitle: 'Configuração do outdoor',
    stepNotSet: 'Ainda por definir',
    stepLocationSet: 'Localização marcada',
    stepNoticeSummary: 'Pré-aviso: {{count}} dia(s)',
    stepPhotosSummary: 'Fotos: {{count}}',
    stepPhotosNone: 'Ainda sem fotos',
    stepBlockedSummary: 'Períodos bloqueados: {{count}}',
    stepOptional: 'Opcional',
    stepFeaturesSummary: 'Selecionadas: {{count}}',
    fixHighlightedFields: 'Alguns dados precisam de correção - abrimos o passo com o problema.',
    instantBooking: 'Reserva imediata',
    instantBookingTooltip: 'Reservado de imediato - sem esperar pela confirmação do fornecedor.',
    instantBookingHint: 'Os anunciantes reservam este outdoor de imediato, sem esperar pela sua aprovação. Deixe desligado para rever cada reserva primeiro.',
    kmAway: 'a {{distance}} km',
    productionCost: 'Custo de produção',
    productionCostIncludes: 'inclui custos de impressão, instalação, etc.',
    priceHiddenTitle: 'Valores diários para contas empresariais',
    priceHiddenMessage: 'Inicie sessão e certifique-se de que está associado a uma entidade empresarial (fornecedor de espaço ou anunciante) para ver o valor diário do outdoor.',
    manageTitle: 'Gerir Outdoors',
    addNew: 'Adicionar Novo Outdoor',
    noOutdoors: 'Nenhum outdoor ainda',
    noOutdoorsDesc: 'Adicione o seu primeiro outdoor para começar a receber reservas.',
    addFirst: 'Adicione o seu primeiro outdoor',
    editTitle: 'Editar Outdoor',
    createTitle: 'Adicionar Novo Outdoor',
    listSubtitle: 'Liste o seu outdoor na Scapow.',
    editSubtitle: 'Atualize os detalhes do seu outdoor.',
    location: 'Localização',
    latitude: 'Latitude',
    longitude: 'Longitude',
    name: 'Nome',
    namePlaceholder: 'ex: Avenida da Liberdade – Outdoor A',
    description: 'Descrição',
    descriptionPlaceholder: 'Outdoor prime na Avenida da Liberdade, zona de grande tráfego…',
    dimensions: 'Dimensões e Especificações',
    width: 'Largura (m)',
    height: 'Altura (m)',
    length: 'Comprimento (m)',
    aspectRatio: 'Proporção do criativo',
    aspectRatioHint: 'Calculado automaticamente a partir de largura ÷ altura',
    bleed: 'Margem de corte (m)',
    bleedHint: 'Área de impressão além do limite de corte final, que garante bordas limpas após o corte.',
    illuminated: 'Iluminado',
    illuminatedHint: 'Este outdoor tem iluminação, mantendo-o visível durante a noite.',
    currency: 'Moeda',
    currencyLockedHint: 'Definida pela moeda da sua conta de Fornecedor.',
    pricing: 'Preços',
    excludeVat: 'sem IVA',
    vatIncluded: 'IVA incluído',
    pricePerDay: 'Preço por dia',
    volumeDiscounts: 'Descontos por volume',
    addDiscount: 'Adicionar',
    daysArrow: 'dias →',
    percentOff: '% desconto',
    photos: 'Fotos da localização',
    photosHint: 'As fotos são guardadas automaticamente ao serem carregadas ou removidas.',
    uploadPhotos: 'Clique para carregar fotos da localização',
    addMorePhotos: 'Adicionar mais fotos',
    currentPhotos: 'Fotos atuais',
    uploadingPhotos: 'A enviar fotos...',
    photosUploaded: 'Fotos enviadas com sucesso',
    deletePhotoTitle: 'Eliminar foto?',
    deletePhotoConfirm: 'Esta foto será removida permanentemente deste outdoor.',
    filesSelected_one: '{{count}} ficheiro selecionado',
    filesSelected_other: '{{count}} ficheiros selecionados',
    blockedTimes: 'Períodos bloqueados',
    blockedTimesDesc:
      'Bloqueie datas em que o outdoor não está disponível (manutenção, pré-reservas externas, etc.).',
    blockedTimesOverlapNote: 'Os intervalos não podem sobrepor-se entre si nem com reservas de campanhas ativas.',
    blockFrom: 'Bloquear de',
    blockUntil: 'Bloquear até',
    addBlockedTime: 'Adicionar período bloqueado',
    noBlockedTimes: 'Sem períodos bloqueados',
    occupiedByCampaign: 'Reservado por uma campanha',
    unsaved: 'Não guardado',
    unsavedChanges: '{{count}} alteração(ões) não guardada(s) - guarde o outdoor para aplicar',
    selectBlockedDates: 'Por favor selecione uma data de início e de fim.',
    legalDeclaration: 'Declaro que tenho direitos legais sobre este espaço publicitário, que estou autorizado a listá-lo comercialmente e que tal está em conformidade com todas as leis, licenças e regulamentos aplicáveis.',
    legalDeclarationRequired: 'Deve confirmar que possui direitos legais sobre este outdoor antes de o publicar.',
    createOutdoor: 'Criar outdoor',
    saveChanges: 'Guardar alterações',
    deleteTitle: 'Eliminar Outdoor',
    deleteConfirm: 'Tem a certeza que quer eliminar este outdoor? Esta ação não pode ser desfeita.',
    hidden: 'Oculto',
    visible: 'Visível',
    viewDetails: 'Ver detalhes',
    bookingRules: 'Regras de reserva',
    bookingRulesDesc: 'Defina os requisitos de antecedência que os anunciantes devem cumprir antes da data de início da campanha.',
    minimumNoticeDays: 'Antecedência mínima (dias)',
    minimumNoticeDaysHint: 'As campanhas devem estar totalmente pagas e o criativo carregado pelo menos este número de dias antes da data de início.',
    minimumDays: 'Duração mínima de aluguer (dias)',
    minimumDaysHint: 'O número mínimo de dias que os anunciantes devem alugar este espaço.',
    acceptingCampaigns: 'A aceitar novas campanhas',
    acceptingCampaignsOn: 'Este outdoor está visível na pesquisa e pode ser adicionado a campanhas.',
    acceptingCampaignsOff: 'Este outdoor está oculto da pesquisa e não receberá novas reservas.',
    acceptingBadge: 'A aceitar campanhas',
    notAcceptingBadge: 'Não aceita campanhas',
    notAcceptingMsg: 'Este outdoor não está a aceitar novas campanhas de momento.',
    unavailableForDates: 'Este outdoor não está disponível para as datas selecionadas.',
    paused: 'Pausado',
    accepting: 'A aceitar',
    availabilityToggleTooltip: 'Se este outdoor está disponível para campanhas ou não. Estado atual: {{state}}',
    availabilityStateOn: 'Disponível',
    availabilityStateOff: 'Indisponível',
    toggleError: 'Falha ao atualizar a visibilidade da campanha.',
    bulkAccept: 'Ativar aceitação de campanhas para todos os outdoors desta página',
    bulkPause: 'Pausar aceitação de campanhas para todos os outdoors desta página',
    commissionNote: 'Os anunciantes irão visualizar o valor de <bold>{{currency}} {{advertiserPrice}}/dia</bold> - os seus {{currency}} {{basePrice}} acrescidos de uma <bold>comissão Scapow de {{rate}}%</bold>.',
    advertiserPaysLabel: 'O anunciante paga',
    advertiserPaysDesc: 'Inclui {{rate}}% de comissão Scapow',
    youReceiveLabel: '{{name}} recebe',
    youReceiveDesc: 'Após taxa de {{rate}}% da plataforma (pode aplicar-se IVA sobre a comissão)',
    searchByAddress: 'Pesquisar por endereço',
    dragPin: 'Arraste o pin para ajustar a posição exata.',
    myOutdoors: 'Os Meus Outdoors',
    myOutdoorsSubtitle: 'Gira o seu inventário de outdoors',
    viewCalendarTooltip: 'Consulte as datas bloqueadas deste Outdoor',
    calendarModalTitle: 'Calendário - {{name}}',
    addOutdoor: 'Adicionar Outdoor',
    searchByName: 'Pesquisar por nome…',
    deleteConfirmNamed: 'Tem a certeza que quer eliminar "{{name}}"? Esta ação não pode ser desfeita.',
    specifications: 'Especificações',
    creativeRatio: 'Proporção do criativo',
    coordinates: 'Coordenadas',
    price: 'Preço',
    plusVat: '+ IVA',
    unavailableDates: 'Datas indisponíveis',
    duration: 'Duração',
    addToCampaign: 'Adicionar à Campanha',
    goToCampaign: 'Ir para a Campanha',
    signInToAdd: 'Inicie sessão/Registe-se para adicionar este Outdoor à sua Campanha',
    bookingsCalendarTitle: 'Calendário de reservas',
    bookingsCalendarSubtitle: 'Veja quando as suas campanhas arrancam, estão no ar e terminam. Escolha um dia para ver que outdoors estão reservados.',
    legend_starting: 'Campanha arranca',
    legend_startingDesc: 'Uma reserva entra no ar',
    legend_running: 'Campanha no ar',
    legend_runningDesc: 'O seu outdoor está em exibição',
    legend_finishing: 'Campanha termina',
    legend_finishingDesc: 'Último dia de uma reserva',
    legend_blocked: 'Datas bloqueadas',
    legend_blockedDesc: 'Outdoors que tornou indisponíveis',
    legend_none: 'Sem reservas',
    legend_noneDesc: 'Nenhum dos seus outdoors está reservado',
    legend_mixed: 'Cores divididas: aplica-se mais do que uma nesse dia',
    calendarToday: 'Hoje',
    selectDayHint: 'Escolha um dia para ver as reservas. Clique novamente para limpar.',
    clearDateSelection: 'Limpar data selecionada',
    dailyStatesError: 'Não foi possível carregar as reservas deste mês. Tente atualizar.',
    searchBookedByName: 'Pesquisar outdoors reservados por nome…',
    clearSearch: 'Limpar pesquisa',
    bookedOutdoorsCount: 'Outdoors reservados: {{count}}',
    noBookingsOnDate: 'Nenhum outdoor reservado neste dia',
    noBookedOutdoorsMatch: 'Nenhum outdoor reservado corresponde a “{{name}}” neste dia',
    noBookingsOnDateHint: 'Escolha outro dia ou limpe a data para ver todos os seus outdoors.',
    bookingPeriod: 'Período da reserva',
    logIn: 'Iniciar sessão',
    register: 'Registar',
    selectCampaignToAdd: 'Por favor, selecione uma campanha para adicionar este outdoor',
    changeCampaign: 'Alterar',
    alreadyInCampaign: 'Já na campanha',
    billboardFallback: 'Outdoor Billboard',
    bookMoreThanDays: 'Reserve mais de {{count}} dias',
    percentageOff: '{{percentage}}% de desconto',
    comingSoon: 'Os seus Outdoors estarão disponíveis em breve!',
    attributes: 'Localizado perto de',
    attributesHint: 'Ajude os anunciantes a encontrá-lo mais facilmente. Assinale o que está próximo para aumentar a visibilidade do seu outdoor nos resultados de pesquisa.',
  },
  outdoorDetail: {
    productionCost: 'Custo de produção',
    bookingTitle: 'Reservar este outdoor',
    startDate: 'Data de início',
    endDate: 'Data de fim',
    estimatedCost: 'Custo estimado',
    addToCart: 'Adicionar ao carrinho',
    inCart: 'Já no carrinho',
    specs: 'Especificações',
    dimensions: 'Dimensões',
    aspectRatio: 'Proporção exigida',
    pricePerDay: 'Preço por dia',
    location: 'Localização',
    blockedTimes: 'Períodos bloqueados',
    discounts: 'Descontos por volume',
    noBlockedTimes: 'Sem períodos bloqueados',
    noDiscounts: 'Sem descontos disponíveis',
    photos: 'Fotos',
    days: 'dias',
    total: 'Total',
    discount: 'desconto',
    campaignBookings: 'Reservas de Campanha',
    inCampaign: 'Em Campanha',
    minimumNoticeInDays: 'Aviso mínimo de reserva',
  },
  campaign: {
    methodFlowLabel: 'Como vai pagar',
    methodFirstPayment: '1.º pagamento',
    methodCard: 'Cartão',
    methodThenMonthly: 'Depois, mensalmente',
    methodThenTrimonthly: 'Depois, a cada 3 meses',
    methodDirectDebit: 'Débito direto',
    searchByName: 'Pesquisar campanhas por nome…',
    clearSearch: 'Limpar pesquisa',
    resultsSummary: 'Resultados: {{total}} · Página {{page}} de {{pages}}',
    noSearchResults: 'Nenhuma campanha corresponde a “{{name}}”',
    noSearchResultsHint: 'Verifique a ortografia ou experimente outro nome.',
    eventFeedbackReceived: 'Um fornecedor respondeu sobre os outdoors da sua campanha.',
    eventConfirmationUpdated: 'A confirmação da sua campanha está concluída - veja o novo estado.',
    eventViewCampaign: 'Ver campanha',
    planTrimonthlyTitle: 'Pagar trimestralmente',
    planTrimonthlyDesc: 'Pague agora os custos de produção e os primeiros 3 meses. Cada trimestre seguinte é cobrado por débito direto no seu primeiro dia.',
    visitCampaignPage: 'Ver página da campanha',
    payStepNotice: 'A disponibilidade dos outdoors é revalidada no pagamento - se algo mudar, avisamos antes de cobrar.',
    removeOutdoor: 'Remover este outdoor',
    noOutdoorsYetDesc: 'Explore o mapa para encontrar outdoors para a sua campanha e escolha as datas.',
    creativesNeedOutdoors: 'Adicione outdoors primeiro - os criativos necessários dependem das suas dimensões.',
    stepAnnounce: 'Passo {{n}} de {{total}}: {{step}}',
    stepsDone: '{{done}} de {{total}} concluídos',
    stepDone: 'Concluído',
    stepToDo: 'Por fazer',
    stepPrevious: 'Voltar: {{step}}',
    stepNext: 'Seguinte: {{step}}',
    stepOutdoorsSummary: 'Outdoors: {{count}}',
    stepCreativesSummary: '{{done}} de {{total}} prontos',
    stepTermsAccepted: 'Aceites',
    stepTermsPending: 'Ainda não aceites',
    stepPendingHint_outdoors: 'Adicione pelo menos um outdoor para continuar.',
    stepPendingHint_creatives: 'Todos os criativos obrigatórios têm de estar carregados e aprovados.',
    stepPendingHint_terms: 'Aceite os termos para desbloquear o pagamento.',
    goToPayment: 'Ir para o pagamento',
    acceptTermsStepLabel: 'Li e aceito os Termos e Condições desta campanha.',
    payStepTitle: 'Rever e pagar',
    payStepMissingTitle: 'Conclua estes passos para pagar:',
    payStepTotal: 'Total da campanha',
    scheduleTitle: 'Plano de pagamentos',
    scheduleTotal: 'Total {{amount}}',
    scheduleFullPayment: 'Pagamento total',
    scheduleFirstPayment: 'Primeiro pagamento · {{month}}',
    scheduleDueAtCheckout: 'Cobrado no pagamento',
    scheduleAuthorisedAtCheckout: 'Autorizado no pagamento, cobrado quando os fornecedores confirmarem',
    scheduleDueOn: 'A {{date}}',
    schedulePaidOn: 'Pago a {{date}}',
    scheduleProcessing: 'Em processamento - os débitos diretos demoram alguns dias',
    scheduleFailed: 'Pagamento falhou',
    scheduleCancelled: 'Cancelado - não será cobrado',
    scheduleSplit: 'Produção {{production}} · Dias de campanha {{ads}}',
    scheduleVatIncluded: 'Todos os valores incluem IVA.',
    paymentsTitle: 'Pagamentos',
    paymentsPaidSoFar: 'Pago até agora',
    paymentsRemaining: 'Falta pagar {{amount}}',
    paymentsFailedNotice: 'Um débito direto não foi concluído. Verifique a sua conta bancária ou contacte-nos para que a campanha não seja interrompida.',
    paymentPlanTitle: 'Como pretende pagar?',
    paymentPlanSubtitle: 'Escolha antes do pagamento. Pode alterar até pagar.',
    planTotalTitle: 'Pagar na totalidade',
    planTotalDesc: 'Um único pagamento para toda a campanha.',
    planMonthlyTitle: 'Pagar mensalmente',
    planMonthlyDesc: 'Pague agora os custos de produção e o primeiro mês. Cada mês seguinte é cobrado por débito direto no dia 1.',
    paymentPlanError: 'Não foi possível atualizar o plano de pagamento.',
    checkoutAllInstant: 'Todos os outdoors são de reserva imediata: é cobrado no pagamento e a campanha fica confirmada de imediato.',
    checkoutNeedsConfirmation: '{{count}} de {{total}} outdoors precisam da confirmação do fornecedor. No pagamento, o seu cartão é apenas autorizado - só é cobrado quando os fornecedores confirmarem, e apenas pelos outdoors aprovados.',
    mandateStepTitle: 'Passo 1 de 2 · Configure o seu débito direto',
    mandateStepDesc: 'A seguir, fará o primeiro pagamento com cartão.',
    confirmingTitle: 'A aguardar a confirmação dos fornecedores',
    confirmingDesc: 'O seu cartão foi autorizado, não cobrado. Só será cobrado pelos outdoors que os fornecedores aprovarem.',
    awaitingDecisionTitle: 'Alguns outdoors não estão disponíveis',
    awaitingDecisionDesc: 'Avance com os outdoors aprovados ou cancele a campanha e liberte o pagamento.',
    providersAnswerBy: 'Os fornecedores respondem até {{date}}',
    decideBy: 'Decida até {{date}} - caso contrário, a campanha é cancelada e nada é cobrado.',
    feedbackCount_approved: 'Aprovados: {{count}}',
    feedbackCount_confirming: 'A aguardar resposta: {{count}}',
    feedbackCount_unavailable: 'Indisponíveis: {{count}}',
    feedbackCount_expired: 'Sem resposta a tempo: {{count}}',
    proceedWithApproved: 'Avançar com os outdoors aprovados',
    proceedNoneApproved: 'Ainda nenhum outdoor foi aprovado.',
    removeConfirmingHint: 'Ainda pode remover outdoors que aguardam resposta.',
    proceedModalTitle: 'Avançar com os outdoors aprovados?',
    proceedOutdoorsLabel: 'Outdoors reservados',
    proceedOutdoorsValue: '{{approved}} de {{total}}',
    proceedChargedLabel: 'Será cobrado',
    proceedTotalMonthlyLabel: 'Total da campanha',
    proceedModalNote: 'Este valor é cobrado agora no seu cartão.',
    proceedModalMonthlyNote: 'O primeiro pagamento é cobrado agora e o restante em prestações, por débito direto.',
    proceedModalDropped: 'Os restantes outdoors ({{count}}) serão removidos desta campanha.',
    proceedSuccess: 'A sua campanha está confirmada.',
    cancelDecisionTitle: 'Cancelar esta campanha?',
    cancelDecisionDesc: 'O pagamento autorizado é libertado e nada é cobrado. Todos os outdoors ficam livres para outros anunciantes.',
    unavailableTitle: 'Nenhum dos outdoors estava disponível',
    unavailableDesc: 'Os fornecedores não puderam confirmar estas datas, por isso nada foi cobrado. Experimente outras datas ou outdoors.',
    feedback_CONFIRMING: 'A aguardar fornecedor',
    feedback_APPROVED: 'Aprovado',
    feedback_UNAVAILABLE: 'Indisponível',
    feedback_EXPIRED: 'Sem resposta',
    creativeThumbnailAlt: 'Criativo da campanha {{name}}',
    title: 'Campanhas',
    newCampaign: 'Nova Campanha',
    newCampaignTooltip: 'Clique para criar uma nova campanha',
    mustRegisterAsAdvertiser: 'Deve registar-se como Anunciante para poder criar Campanhas',
    noCampaigns: 'Ainda sem campanhas',
    noCampaignsDesc: 'Crie a sua primeira campanha para começar a anunciar em outdoors.',
    browseSpaces: 'Explorar espaços de outdoor',
    status: 'Estado',
    from: 'De',
    to: 'Até',
    filter: 'Filtrar',
    clearFilter: 'Limpar filtro',
    outdoorSlots: 'Outdoors',
    outdoorsColHeader: 'Outdoors',
    startDate: 'Data de início',
    endDate: 'Data de fim',
    paginationRange: 'Campanhas {{from}}-{{to}} de {{total}}',
    creatives: 'Criativos',
    payment: 'Pagamento',
    deleteTitle: 'Eliminar Campanha',
    deleteConfirm: 'Tem a certeza que quer eliminar esta campanha? Esta ação não pode ser desfeita.',
    uploadCreative: 'Carregar criativo',
    removeCreative: 'Remover',
    deletingCreative: 'A eliminar criativo…',
    creativeRatioMismatch: 'A proporção da imagem não corresponde ao formato {{ratio}} necessário. Por favor, carregue uma imagem com as proporções corretas ou um PDF.',
    getPaymentDetails: 'Obter detalhes de pagamento',
    requiredRatios: 'Proporções de criativo exigidas',
    iban: 'IBAN',
    reference: 'Referência de pagamento',
    viewCampaign: 'Ver',
    loading: 'A carregar campanhas…',
    noSlots: 'Nenhum espaço de outdoor nesta campanha.',
    noCreatives: 'Ainda sem criativos carregados.',
    subtitle: 'Gira as suas campanhas de publicidade exterior',
    noFound: 'Nenhuma campanha encontrada',
    noFoundDesc: 'Comece por adicionar outdoors ao seu carrinho para criar a sua primeira campanha.',
    browseOutdoors: 'Explorar outdoors',
    outdoorsCount: '{{count}} outdoor',
    outdoorsCount_plural: '{{count}} outdoors',
    creativesCount: '{{count}} criativos',
    paymentLabel: 'Pagamento: {{status}}',
    backToCampaigns: 'Voltar às Campanhas',
    checklistTitle: 'Lista de verificação da campanha',
    checklistOutdoors: 'Escolha outdoors para a sua campanha',
    checklistCreatives: 'Adicionar criativos',
    checklistTerms: 'Aceitar os Termos e Condições',
    checklistPay: 'Pagar a campanha',
    acceptTermsPrefix: 'Aceito os',
    acceptTermsLink: 'Termos e Condições',
    acceptTermsRequiredHint: 'Tem de aceitar os Termos e Condições antes de pagar esta campanha.',
    advertiserTermsModalTitle: 'Termos e Condições para Anunciantes e Campanhas',
    advertiserTermsModalHint: 'Estas são as secções dos nossos Termos e Condições que se aplicam especificamente a anunciantes e campanhas.',
    viewFullTerms: 'Ver Termos e Condições completos',
    outdoorsHeader: 'Outdoors ({{count}})',
    noOutdoorsYet: 'Ainda sem outdoors adicionados.',
    requiredAspectRatios: 'Proporções de criativo exigidas',
    recResolution: 'recomendado: {{w}}×{{h}} cm @ {{dpi}} dpi (1:{{scale}})',
    recInclBleed: 'incl. margem de corte',
    dimensionsCalculatorBleedNote: 'Este espaço publicitário tem {{bleed}} cm de margem de corte em cada lado, por isso as dimensões cobrem toda a área de impressão de {{w}} × {{h}} m (a área visível é de {{trimW}} × {{trimH}} m).',
    orientationLandscape: 'Paisagem',
    orientationPortrait: 'Retrato',
    dimensionsCalculatorTooltip: 'Calcular possíveis dimensões do criativo',
    dimensionsCalculatorTitle: 'Calculadora de dimensões para criativo com proporção {{ratio}}',
    dimensionsCalculatorHint: 'Altere a largura ou a altura (em centímetros) e o outro lado é atualizado automaticamente para manter esta proporção. Trabalhamos sempre a 300 dpi, favorecendo uma escala de 1:10 do tamanho real do espaço publicitário.',
    dimensionsCalculatorWidthLabel: 'Largura (cm)',
    dimensionsCalculatorHeightLabel: 'Altura (cm)',
    dimensionsCalculatorDpiLabel: 'Resolução de impressão',
    dimensionsCalculatorScaleHint: 'Escala: 1:{{scale}} - recomendamos 1:10 ou um design maior (número de escala menor).',
    dimensionsCalculatorExportHint: 'Exporte o seu ficheiro a {{w}} × {{h}} px.',
    dimensionsCalculatorMinQualityWidth: 'Demasiado pequeno para boa qualidade de impressão - são necessários pelo menos {{min}} cm para um design em escala 1:{{scale}}.',
    dimensionsCalculatorMinQualityHeight: 'Demasiado pequeno para boa qualidade de impressão - são necessários pelo menos {{min}} cm para um design em escala 1:{{scale}}.',
    processingImage: 'A processar imagem...',
    noCreativesYet: 'Ainda sem criativos carregados',
    creativesNote: 'Estas são as imagens que serão exibidas nos suportes de publicidade exterior ao longo da sua campanha.',
    clickToUpload: 'Clique para carregar',
    creativeValid: 'Aprovado',
    creativeUnderReview: 'Em revisão',
    creativeInvalid: 'Inválido',
    deleteCreativeTitle: 'Eliminar criativo?',
    deleteCreativeBody: 'Este criativo foi aprovado ou está em revisão. Ao eliminá-lo, será removido da campanha e será necessário fazer um novo upload.',
    campaignInfo: 'Info da Campanha',
    details: 'Detalhes',
    requestPayment: 'Solicitar Pagamento',
    paymentDetails: 'Detalhes de Pagamento',
    currency: 'Moeda',
    bankTransferDetails: 'Detalhes de transferência bancária',
    amount: 'Montante',
    importantRef: '⚠️ Importante - Referência de Pagamento',
    refNote: 'Deve incluir esta referência na descrição da sua transferência para que seja correspondida automaticamente.',
    deleteCampaign: 'Eliminar Campanha',
    deleteCampaignDesc: 'Isto eliminará permanentemente esta campanha e todos os dados associados. Esta ação não pode ser desfeita.',
    addOutdoor: 'Adicionar Outdoor',
    outdoorAdded: 'Outdoor adicionado à campanha',
    selectOutdoor: 'Selecione um outdoor',
    outdoorDateConflict: 'Este outdoor já está reservado nesta campanha para datas sobrepostas. Por favor escolha datas diferentes.',
    alreadyInCampaign: 'Na campanha',
    name: 'Nome',
    outdoorSubtotal: 'Subtotal',
    bankTransferNoticeTitle: 'Pagamento de Campanha Necessário',
    bankTransferNotice: 'A sua campanha apenas será ativada e todos os espaços formalmente reservados após confirmação integral do pagamento. Clique em "Validar e Pagar" para avançar. Nota: a disponibilidade dos outdoors é revalidada no momento do checkout - espaços disponíveis quando adicionados à campanha podem já não estar garantidos.',
    requestPaymentDisabledHint: 'Todos os {{count}} criativos necessários têm de ser carregados e validados (estado: Válido) antes de poder solicitar o pagamento.',
    outdoorRemoved: 'Espaço removido da campanha.',
    removeOutdoorConfirm: 'Tem a certeza que pretende remover este espaço da campanha? Esta ação não pode ser desfeita.',
    qualityFail: 'Resolução insuficiente - ficheiro não carregado',
    qualityWarn: 'Proporção não corresponde - a imagem pode ser cortada ou ter margens',
    qualityAspectMismatch: 'Proporção {{actual}} vs {{expected}} (outdoor)',
    qualityUploadAnyway: 'Enviar mesmo assim',
    qualityConfirmHint: 'A imagem pode ser cortada ou ter margens para se adaptar a este formato.',
    qualityDetailFail: 'Este ficheiro só tem nitidez suficiente para {{achievedScale}} num espaço publicitário de {{outdoorW}} × {{outdoorH}} m.',
    qualityTargetFail: 'Desenhe a sua peça a {{w}} × {{h}} cm (escala 1:{{scale}}, {{dpi}} dpi) para este formato.',
    recResolutionPx: 'recomendado: {{w}}×{{h}}px @ {{dpi}} dpi',
    dimensionsCalculatorHintPx: 'Altere a largura ou a altura e o outro lado é atualizado automaticamente para manter esta proporção - o DPI efetivo também é atualizado, para que possa encontrar dimensões alternativas que ainda imprimam com boa qualidade.',
    dimensionsCalculatorWidthLabelPx: 'Largura (px)',
    dimensionsCalculatorHeightLabelPx: 'Altura (px)',
    dimensionsCalculatorDpiLabelPx: 'DPI efetivo',
    dimensionsCalculatorMinDpiHintPx: 'São necessários pelo menos {{dpi}} dpi para este espaço publicitário.',
    dimensionsCalculatorMinQualityWidthPx: 'Qualidade mínima de largura ainda não atingida (mín. {{min}}px, recomendado: {{rec}}px).',
    dimensionsCalculatorMinQualityHeightPx: 'Qualidade mínima de altura ainda não atingida (mín. {{min}}px, recomendado: {{rec}}px).',
    qualityWarnLowRes: 'Baixa resolução - a imagem pode imprimir com má qualidade',
    qualityConfirmHintLowRes: 'A imagem pode imprimir com perda de qualidade visível.',
    qualityDetailWarnPx: '{{pixelW}} × {{pixelH}} px produz {{dpi}} DPI em tamanho real.',
    qualityDetailFailPx: '{{pixelW}} × {{pixelH}} px produz {{dpi}} DPI a {{outdoorW}} × {{outdoorH}} m, abaixo do mínimo de {{minDpi}} DPI.',
    qualityTargetWarnPx: 'Recomendamos pelo menos {{recDpi}} DPI para este formato: {{recW}} × {{recH}} px, ou {{recScaleLabel}}.',
    qualityTargetFailPx: 'Precisa de pelo menos {{minW}} × {{minH}} px - a trabalhar em 1:{{scale}}, isso é uma tela de {{canvasW}} × {{canvasH}} m a {{designDpi}} DPI.',
    creativeUnitLabel: 'Unidades de tamanho',
    creativeUnitCm: 'Centímetros',
    creativeUnitPx: 'Píxeis',
    creativeUnitHint: 'Escolha como os tamanhos recomendados dos criativos são mostrados e verificados. Centímetros: desenhe numa escala de 1:10 do espaço publicitário, sempre a 300 dpi. Píxeis: resolução mínima com base no tamanho do espaço publicitário.',
    previewBadge: 'Pré-visualização',
    previewOnlyHint: 'Apenas pré-visualização - descarregue o original para imprimir',
    downloadPrintFile: 'Descarregar ficheiro de impressão',
    downloadPrintFileHint: 'Original em resolução total',
    printFileExplainer: 'A imagem acima é uma pré-visualização leve. Descarregue o ficheiro original, em resolução total, para enviar para impressão.',
    previewFailed: 'Não foi possível preparar uma pré-visualização deste ficheiro no seu navegador. Exporte-o como JPG ou PNG e tente novamente.',
    creativeFileRequirements: 'Ficheiros aceites: TIF, TIFF, JPG, JPEG, PNG ou PDF. A impressão requer o modo de cor CMYK. As imagens noutros modos de cor são convertidas para CMYK, com uma pré-visualização para aprovar antes do envio. Os ficheiros PDF já devem estar em CMYK.',
    creativeFormatNotAllowed: '"{{name}}" não é um tipo de ficheiro aceite. Carregue um ficheiro TIF, TIFF, JPG, JPEG, PNG ou PDF.',
    creativeNotCmykPdf: '"{{name}}" contém cores RGB (na arte ou numa imagem incorporada). Os ficheiros de impressão têm de estar totalmente em CMYK - exporte-o novamente com um perfil de cor CMYK (ex.: PDF/X-1a) e carregue-o.',
    creativeUnreadable: 'Não foi possível ler "{{name}}". Pode estar danificado ou guardado num formato invulgar - exporte-o novamente e tente outra vez.',
    cmykNoticeTitle: '"{{name}}" não está em modo de cor CMYK',
    cmykNoticeBody: 'A impressão requer CMYK. Podemos convertê-lo por si com o perfil padrão para impressão exterior e poderá rever uma pré-visualização do antes e depois antes de qualquer envio.',
    cmykConvert: 'Converter para CMYK',
    cmykModalTitle: 'Converter para CMYK para impressão',
    cmykConverting: 'A converter para CMYK ({{profile}})…',
    cmykBefore: 'Original',
    cmykAfter: 'Pré-visualização de impressão (CMYK)',
    cmykShiftWarning: 'Algumas cores vivas ficarão visivelmente diferentes na impressão (cerca de {{percent}}% da imagem). Se as cores exatas forem importantes, ajuste a arte no seu software de design antes de carregar.',
    cmykProfileNote: 'Convertido com o perfil {{profile}}, o padrão para impressão exterior. Os ecrãs não conseguem mostrar CMYK com exatidão, por isso a pré-visualização simula o resultado impresso.',
    cmykAccept: 'Aceitar versão CMYK convertida',
    cmykErrorUnavailable: 'A conversão para CMYK está temporariamente indisponível. Converta o ficheiro para CMYK no seu software de design e carregue-o novamente.',
    cmykErrorTooLarge: 'Esta imagem é demasiado grande para ser convertida no navegador. Converta-a para CMYK no seu software de design e carregue-a novamente.',
    cmykErrorFailed: 'Não foi possível converter este ficheiro. Converta-o para CMYK no seu software de design e carregue-o novamente.',
    pay: 'Validar e Pagar',
    commission: 'Comissão da plataforma ({{rate}}%)',
    vatLabel: 'IVA',
    vatWithRate: 'IVA ({{rate}}%)',
    vatDetailsTitle: 'Detalhes do IVA',
    vatDetailsBody: 'O IVA é calculado de acordo com o tratamento fiscal aplicável a cada componente da campanha. Alguns valores podem incluir IVA, estar sujeitos a uma taxa de IVA diferente, ou não estar abrangidos pela base de incidência do IVA aplicável.',
    totalWithoutVat: 'Total (sem IVA)',
    grandTotal: 'Total',
    dailyRateRoundingNote: 'Os valores diários são arredondados ao cêntimo.',
    platformFeeNote: '* Os valores diários dos espaços já incluem uma comissão de plataforma de 5%.',
    confirmPayment: 'Confirmar Pagamento',
    paymentSuccess: 'Pagamento efetuado com sucesso! A sua campanha será ativada em breve.',
    checkingPayment: 'A verificar o seu pagamento…',
    paymentConfirmed: 'Pagamento Confirmado!',
    paymentConfirmedDesc: 'O seu pagamento foi confirmado. A sua campanha será ativada em breve.',
    paymentPending: 'Pagamento Não Confirmado',
    paymentPendingDesc: 'Não foi possível confirmar o seu pagamento neste momento. Por favor tente novamente ou contacte o suporte.',
    backToCampaign: 'Voltar à Campanha',
    expandPricing: 'Mostrar detalhes de preços',
    collapsePricing: 'Ocultar detalhes de preços',
    availabilityUpdated: 'Um ou mais espaços foram removidos da sua campanha - foram reservados por outra campanha para datas sobrepostas, ou o período mínimo de antecedência já tinha expirado. Por favor, reveja a seleção atualizada abaixo.',
    availabilityDialogTitle: 'Confirmar disponibilidade e prosseguir para pagamento',
    availabilityDialogBody: 'Antes de continuar, iremos verificar se todos os outdoors selecionados continuam disponíveis. Alguns podem ter sido reservados por outras campanhas entretanto. Indique como pretende gerir eventuais conflitos.',
    availabilityRemoveYes: 'Sim - remover automaticamente os outdoors indisponíveis',
    availabilityRemoveYesDesc: 'Os outdoors que já não estejam disponíveis serão removidos desta campanha. Poderá rever a seleção atualizada antes de efetuar o pagamento.',
    availabilityRemoveNo: 'Não - assinalar conflitos e rever manualmente',
    availabilityRemoveNoDesc: 'Os outdoors em conflito serão destacados para que possa ajustar as datas ou removê-los manualmente antes de prosseguir.',
    availabilityDialogConfirm: 'Prosseguir para pagamento',
    outdoorFlaggedTitle: 'Datas já não disponíveis',
    outdoorFlaggedDesc: 'Este outdoor foi reservado por outra campanha para datas sobrepostas. Edite as datas ou remova-o para prosseguir.',
    outdatedOutdoorsTitle: 'A campanha não pode prosseguir - outdoors desatualizados detetados',
    outdatedOutdoorsDesc: 'Um ou mais outdoors da campanha têm uma data de início que já passou. O pagamento não foi processado. Reveja os outdoors assinalados abaixo e atualize as datas de início antes de tentar novamente.',
    outdoorOutdatedTitle: 'Data de início no passado',
    outdoorOutdatedDesc: 'A data de início prevista para este outdoor já passou. Atualize-a para uma data futura para continuar.',
    pastStartDatesToast: 'As datas da campanha não podem estar no passado.',
    cancelCampaign: 'Cancelar Campanha',
    cancelCampaignConfirm: 'Esta ação irá cancelar permanentemente a sua campanha. Tem a certeza?',
    cancelCampaignYes: 'Sim, cancelar',
    cancelCampaignAbort: 'Manter campanha',
    cancelledSuccess: 'A campanha foi cancelada.',
    cancellationPolicyPending: 'Cancelamento gratuito - não são aplicadas cobranças enquanto a sua campanha estiver no estado Pendente.',
    cancellationPolicyReady: 'Cancelamento gratuito se todos os outdoors forem cancelados com mais dias de antecedência do que o prazo de pré-aviso mínimo do respetivo Fornecedor de Espaço. Aplica-se uma taxa de cancelamento se um ou mais outdoors se encontrarem dentro do seu prazo de pré-aviso mínimo (acrescida de IVA para empresas portuguesas). Os custos de produção (impressão, instalação, etc.) não são reembolsáveis para qualquer outdoor dentro do prazo de pré-aviso mínimo.',
    cancellationPolicyRunning: 'Atenção: o cancelamento de uma campanha já em execução implica a perda de 100% do valor da campanha. Não será emitido qualquer reembolso.',
    ppInvoices: 'Faturas dos Fornecedores de Espaço',
    outdoorAdj0: 'incríveis',
    outdoorAdj1: 'fantásticos',
    outdoorAdj2: 'magníficos',
    outdoorAdj3: 'fabulosos',
    outdoorAdj4: 'excecionais',
    outdoorsCollapsedSummary: 'Temos aqui {{count}} outdoors {{adj}}!',
    messages: 'Mensagens',
    noMessages: 'Nenhum fornecedor de espaço enviou ainda mensagens relativas a esta campanha. Assim que o fizerem, as conversas aparecerão aqui.',
    noMessagesYet: 'Ainda não há mensagens nesta conversa.',
    typeMessage: 'Escreva uma mensagem…',
    instructions: 'Instruções para os Fornecedores de Espaço',
    instructionsPlaceholder: 'ex. Por favor, exiba esta campanha apenas das 8h às 22h.',
    instructionsEmpty: 'Ainda não foram adicionadas instruções. Clique em Editar para adicionar orientações.',
    instructionsSaved: 'Instruções guardadas.',
    proofOfDisplay: 'Prova de Exposição',
    proofPending: 'Prova em breve',
    proofPendingDesc: 'O fornecedor do espaço submeterá a prova de exposição em breve.',
    proofAlt: 'Prova de exposição – {{name}}',
    additionalFiles: 'Ficheiros Adicionais',
    additionalFilesSubtitle: 'Materiais de apoio para esta campanha - não obrigatórios.',
    additionalFilesSubtitlePP: 'Materiais de apoio partilhados pelo anunciante.',
    noAdditionalFiles: 'Ainda não foram carregados ficheiros adicionais.',
    uploadFile: 'Carregar ficheiro',
    fileUploaded: 'Ficheiro carregado com sucesso.',
    fileDeleted: 'Ficheiro removido.',
    deleteFile: 'Eliminar ficheiro',
    addOutdoors: 'Adicionar outdoors',
    creativesLockedTitle: 'Nenhum outdoor adicionado ainda',
    creativesLockedDesc: 'Os criativos devem corresponder à resolução exigida por cada outdoor. Adicione pelo menos um outdoor para desbloquear os envios.',
    editDates: 'Editar datas',
    updateDates: 'Atualizar datas',
    datesUpdated: 'Datas atualizadas com sucesso',
  },
  dashboard: {
    title: 'Painel',
    earnings: 'Receitas',
    spendings: 'Gastos',
    last30: 'Últimos 30 dias',
    last90: 'Últimos 90 dias',
    thisYear: 'Este ano',
    accessRequests: 'Pedidos de Acesso',
    noRequests: 'Sem pedidos pendentes',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    teamInvite: 'Convidar Membro da Equipa',
    inviteEmail: 'Endereço de email',
    sendInvite: 'Enviar Convite',
    totalEarned: 'Total recebido',
    totalSpent: 'Total gasto',
    activeOutdoors: 'Outdoors ativos',
    activeCampaigns: 'Campanhas ativas',
    overview: 'Visão geral',
    howPaidTitle: 'Como irá receber',
    howPaidDesc: 'Quando uma campanha estiver ativa, carregue uma prova fotográfica para cada outdoor. Quando todos os comprovativos forem verificados, o seu pagamento é processado automaticamente. O seu pagamento é calculado com base na sua tarifa diária multiplicada pelo número de dias ativos da campanha, líquida de uma comissão de serviço da plataforma de 5% aplicada por reserva.',
    ppOverview: 'Visão geral do Fornecedor de Espaços',
    advertiserOverview: 'Visão geral do Anunciante',
    findOutdoors: 'Encontrar Outdoors',
    addOutdoor: 'Adicionar Outdoor',
    viewCampaigns: 'Ver Campanhas',
    manageOutdoors: 'Gerir Outdoors',
    companyDetails: 'Detalhes da Empresa',
    userDetails: 'Detalhes da Conta',
    pendingRequests: 'Pedidos de Acesso Pendentes ({{count}})',
    inviteDesc: 'Receberão um email com um link para se juntar à sua empresa na Scapow.',
    invitePlaceholder: 'colega@empresa.com',
    invoicesTitle: 'Faturas',
    downloadInvoice: 'Transferir',
    invoiceIssued: 'Emitida',
    invoicePaid: 'Paga',
    invoiceUnknownCampaign: 'Campanha desconhecida',
    invoicesSubtitle: 'O seu histórico de pagamentos e documentos de fatura para descarregar.',
    invoicesEmpty: 'As suas faturas aparecerão aqui assim que estiverem disponíveis.',
  },
  invoices: {
    title: 'Faturas',
    subtitleAdvertiser: 'Faturas da Scapow e dos proprietários de espaços em todas as suas campanhas.',
    subtitlePP: 'O seu histórico de pagamentos e faturas para descarregar.',
    issued: 'Emitida em',
    download: 'Descarregar',
    empty: 'Ainda sem faturas. Aparecerão aqui assim que as suas campanhas forem processadas.',
    unknownCampaign: 'Campanha desconhecida',
    ppInvoices: 'Faturas de proprietários ({{count}})',
    unknownProvider: 'Fornecedor desconhecido',
    notAvailable: 'Não disponível',
    typeInvoice: 'Fatura',
    typeCreditNote: 'Nota de Crédito',
  },
  payments: {
    title: 'Pagamentos',
    subtitle: 'O seu histórico de pagamentos das campanhas realizadas nos seus espaços.',
    empty: 'Ainda sem pagamentos. Aparecerão aqui assim que as suas campanhas forem pagas.',
    unknownCampaign: 'Campanha desconhecida',
    columnId: 'ID do pagamento',
    columnCampaign: 'Campanha',
    columnValue: 'Valor',
    columnPaidAt: 'Pago em',
    columnStatus: 'Estado',
    statusPaid: 'Pago',
    statusTransferRequested: 'Transferência solicitada',
  },
  userDetails: {
    receiveEmails: 'Receber emails',
    receiveEmailsOnDesc: 'Os emails da plataforma são enviados para {{email}}.',
    receiveEmailsOffDesc: 'Não vai receber emails da plataforma. Ative para voltar a recebê-los.',
    emailsTurnedOn: 'Vai receber emails da plataforma.',
    emailsTurnedOff: 'Deixará de receber emails da plataforma.',
    emailsUpdateError: 'Não foi possível atualizar a sua preferência de email.',
    title: 'Detalhes da conta',
    subtitle: 'Faça a gestão das informações da sua conta pessoal.',
    name: 'Nome',
    editName: 'Clique para editar',
    email: 'Email',
    memberSince: 'Membro desde (UTC)',
    accountStatus: 'Estado da conta',
    statusVerified: 'Verificado',
    statusPending: 'Verificação pendente',
    nameUpdated: 'Nome atualizado com sucesso.',
    nameRequired: 'Introduza um nome válido (mínimo 2 caracteres).',
    password: 'Palavra-passe',
    changePassword: 'Alterar palavra-passe',
    currentPassword: 'Palavra-passe atual',
    newPassword: 'Nova palavra-passe',
    confirmNewPassword: 'Confirmar nova palavra-passe',
    passwordUpdated: 'Palavra-passe atualizada com sucesso.',
    passwordFieldsRequired: 'Por favor, preencha todos os campos da palavra-passe.',
    passwordTooShort: 'A nova palavra-passe deve ter pelo menos 8 caracteres.',
    passwordSameAsCurrent: 'A nova palavra-passe deve ser diferente da palavra-passe atual.',
    passwordMismatch: 'A nova palavra-passe e a confirmação não coincidem.',
  },
  admin: {
    tabUnpaidInstallments: 'Prestações em atraso',
    unpaidInstallmentsIntro: 'Prestações ainda por pagar 6 dias após a data de vencimento, das mais antigas para as mais recentes.',
    noUnpaidInstallments: 'Não há prestações em atraso.',
    installmentOf: 'Prestação {{number}} de {{total}}',
    installmentNumber: 'Prestação {{number}}',
    installmentDue: 'Vence a {{date}}',
    installmentOverdueDays_one: '{{count}} dia em atraso',
    installmentOverdueDays_other: '{{count}} dias em atraso',
    proofOfCompany: 'Comprovativo da empresa',
    openProofOfCompany: 'Abrir {{name}} num novo separador',
    noProofOfCompany: 'Sem comprovativo da empresa carregado',
    proofLocationLoading: 'A procurar a morada…',
    proofLocationViewMap: 'Ver no mapa',
    title: 'Painel de Administração',
    verifications: 'Verificações',
    advertisers: 'Anunciantes',
    providers: 'Fornecedores',
    payments: 'Pagamentos',
    noVerifications: 'Sem verificações pendentes',
    noPayments: 'Sem pagamentos pendentes',
    markAsDone: 'Marcar como concluído',
    business: 'Empresa',
    type: 'Tipo',
    status: 'Estado',
    actions: 'Ações',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    subtitle: 'Gestão e moderação da plataforma',
    proofVerification: 'Verificações Manuais',
    accessRequestsTab: 'Pedidos de Acesso',
    noAccessRequests: 'Sem pedidos de acesso pendentes.',
    noAdvertisers: 'Nenhum anunciante encontrado.',
    noProviders: 'Nenhum fornecedor encontrado.',
    noPaymentsStatus: 'Sem pagamentos com este estado.',
    campaignOutdoor: 'Outdoor da campanha: {{id}}',
    campaignFrom: 'Campanha de {{date}}',
    adCreative: 'Criativo publicitário',
    proofPhotos: 'Fotos de comprovativo ({{count}}) - clique para abrir em tamanho completo',
    period: 'Período',
    outdoorsLabel: 'outdoors',
    campaignsLabel: 'campanhas',
    spentLabel: 'gasto',
    earnedLabel: 'recebido',
    markAsPaid: 'Marcar como Pago',
    tabAds: 'Anúncios',
    tabBusinessProofs: 'Comprovativos de Empresa',
    tabProofOfAds: 'Comprovativos de Anúncios',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    noAds: 'Sem verificações de anúncios pendentes.',
    noBusinessProofs: 'Sem comprovativos de empresa pendentes.',
    noProofOfAds: 'Sem comprovativos de anúncios pendentes.',
    refundsTab: 'Reembolsos e Dívidas',
    refundsSearchPlaceholder: 'Pesquisar por nome de campanha ou anunciante…',
    refundsNoCampaigns: 'Nenhuma campanha encontrada.',
    refundsSelectOutdoors: 'Selecionar outdoors para reembolso',
    refundsSelectAll: 'Selecionar todos',
    refundsDeselectAll: 'Desselecionar todos',
    refundsNoEligible: 'Nenhum outdoor elegível encontrado para esta campanha.',
    refundsEligibleNote: 'Apenas outdoors não rejeitados são elegíveis para reembolso.',
    refundsSubmit: 'Processar Reembolso',
    refundsSuccess: 'Reembolso processado com sucesso.',
    refundsSubTabRefunds: 'Reembolsos a Anunciantes',
    refundsSubTabDebts: 'Dívidas de Fornecedores',
    refundTypeTotal: 'Total',
    refundTypePartial: 'Parcial',
    refundDaysLabel: 'Dias a reembolsar',
    refundDaysHint: 'Máx. {{max}} dias',
    debtNoDebts: 'Sem dívidas pendentes de fornecedores.',
    debtSettle: 'Liquidar',
    debtSettleAmount: 'Valor da liquidação',
    debtSettleDoc: 'Documento de liquidação',
    debtSettleDocHint: 'Carregue o documento de liquidação assinado (PDF, imagem, etc.)',
    debtSettleConfirm: 'Carregar e liquidar',
    debtSettleSuccess: 'Dívida liquidada e documento carregado com sucesso.',
    debtStatusOutstanding: 'Pendente',
    debtStatusSettled: 'Liquidado',
    debtCampaign: 'Campanha',
    campaignsTab: 'Campanhas',
    noCampaigns: 'Nenhuma campanha encontrada.',
    accessRequestFor: 'Solicitando acesso a: {{entity}}',
    tabByStatus: 'Por Estado',
    tabTransferRequested: 'Transferência Solicitada',
    checkPayment: 'Verificar',
    lastCheckedAt: 'Última verificação',
    neverChecked: 'Nunca verificado',
    noTransferRequested: 'Nenhum pagamento com transferência solicitada.',
    checkSuccess: 'Verificação de pagamento iniciada.',
    revenueTitle: 'Receita',
    revenueSubtitle: 'Comissão da plataforma e IVA por período de faturação',
    revenueGross: 'Receita bruta',
    revenueCommission: 'Comissão',
    revenueVat: 'IVA',
    revenueStripeFees: 'Taxas Stripe',
    revenueNet: 'Receita líquida',
    revenueEmpty: 'Sem receita registada para este período.',
    revenueMonth: 'Mês',
    revenueYear: 'Ano',
    revenueDailyTitle: 'Detalhe Diário',
    revenueNoDaily: 'Sem dados diários para este período.',
    searchByName: 'Pesquisar por nome…',
    importOutdoorsFromFile: 'Importar outdoors de ficheiro',
    chooseFile: 'Escolher ficheiro…',
    csvSend: 'Enviar',
    importOutdoorsSuccess: 'Ficheiro de outdoors enviado com sucesso.',
    remainingFreeCommissions: 'Comissões grátis restantes: {{count}}',
    setFreeCommissions: 'Definir novas comissões grátis restantes',
    freeCommissionsUpdated: 'Comissões grátis restantes atualizadas.',
    freeCommissionsUpdateFailed: 'Não foi possível atualizar as comissões grátis restantes.',
    verified: 'Verificado',
  },
  ppCampaigns: {
    searchAllStatuses: 'A mostrar campanhas em todos os estados. Limpe a pesquisa para filtrar por estado.',
    typeAll: 'Todas',
    typeScapow: 'Scapow',
    typeOffline: 'Offline',
    typeFilterLabel: 'Tipo de campanha',
    noOfflineResults: 'Ainda não há campanhas offline. Adicione outdoors a uma a partir da página Outdoors.',
    goToOutdoors: 'Ir para Outdoors',
    offlineBadge: 'Offline',
    moreOutdoors: '+{{count}} mais',
    offlineNotes: 'Notas',
    payoutCommission: 'Comissão da plataforma',
    payoutCommissionVat: 'IVA sobre a comissão da plataforma',
    payoutTransferred: 'Transferido',
    payoutValueWithoutVat: 'Valor publicitário (sem IVA)',
    payoutVat: 'IVA',
    payoutProduction: 'Custos de produção (IVA incl.)',
    payoutsTitle: 'Pagamentos a receber',
    payoutsCount: 'Pagamentos: {{count}}',
    payoutsReceived: 'Recebido até agora',
    payoutFull: 'Pagamento total',
    payoutFirst: 'Primeiro pagamento · {{month}}',
    payoutAfterProof: 'Previsto a partir de {{date}}, após aprovação da prova de exibição',
    payoutExpectedOn: 'Previsto a {{date}}',
    payoutReceivedOn: 'Recebido a {{date}}',
    payoutProcessing: 'Transferência em curso',
    payoutOnHold: 'Em espera - o débito direto do anunciante falhou',
    payoutsOnHoldNotice: 'Um pagamento está em espera porque o débito direto do anunciante falhou. Será libertado assim que esse pagamento for concluído.',
    payoutsNetNote: 'Valores líquidos da comissão Scapow e respetivo IVA, antes de eventuais dívidas pendentes.',
    colProduction: 'Produção',
    title: 'Campanhas',
    subtitle: 'Monitorize e gira as campanhas que incluem os seus espaços outdoor.',
    tabPending: 'Pendentes',
    tabReady: 'Prontas',
    tabRunning: 'Em Execução',
    tabCompleted: 'Concluídas',
    noResults: 'Nenhuma campanha encontrada para este estado.',
    outdoorSlots: '{{count}} espaço outdoor',
    outdoorSlots_plural: '{{count}} espaços outdoor',
    instructions: 'Instruções do anunciante',
    backToCampaigns: 'Voltar às Campanhas',
    yourSlots: 'Os Seus Espaços Outdoor',
    noSlots: 'Nenhum espaço outdoor da sua propriedade encontrado nesta campanha.',
    advertiserInstructions: 'Instruções do Anunciante',
    messagesWithAdvertiser: 'Mensagens com o Anunciante',
    noConversation: 'Ainda sem mensagens. Inicie uma conversa com o anunciante escrevendo abaixo.',
    myInvoice: 'A Minha Fatura ao Anunciante',
    uploadInvoice: 'Enviar Fatura',
    replaceInvoice: 'Substituir Fatura',
    uploadInvoiceSuccess: 'Fatura enviada com sucesso.',
    invoiceUploaded: 'Ver fatura',
    noInvoiceYet: 'Ainda não foi enviada nenhuma fatura.',
    creativesAndOutdoors: 'Criativos & Os seus espaços',
    noCreativeForRatio: 'Nenhum criativo carregado para este formato ainda.',
    yourOutdoorsForFormat: 'Os seus espaços para este formato',
    viewOutdoor: 'Ver espaço',
    goToCampaign: 'Ir para a página da campanha',
    yourEarnings: 'Os seus rendimentos',
    readyPaymentTitle: 'Verificação de afixações necessária',
    readyPaymentNoteReady: 'Os seus rendimentos estão assegurados enquanto aguarda o lançamento da campanha. Assim que estiver ativa, carregue o comprovativo de instalação de cada espaço outdoor para iniciar o pagamento.',
    readyPaymentNote: 'Para receber o seu pagamento, por favor fa;a upload do comprovativo de instalação de cada espaço outdoor no passo Verificar Afixações.',
    readyPaymentCta: 'Ir para Verificar Afixações',
    paymentPaidTitle: 'Pagamento recebido',
    paymentPaidDesc: 'Os seus ganhos desta campanha já foram pagos.',
    viewBreakdown: 'ver detalhes',
    earningsBreakdown: 'Detalhes dos rendimentos',
    colDays: 'Dias',
    colNetDailyValue: 'Valor Diário + IVA',
    colEarnings: 'Receita',
  },
  upcomingCampaigns: {
    title: 'Próximas Campanhas',
    subtitle: 'Campanhas prontas a iniciar que incluem os seus espaços publicitários.',
    noResults: 'Não foram encontradas próximas campanhas.',
  },
  getPaid: {
    title: 'Receber Pagamento',
    subtitle: 'Siga os passos abaixo para verificar as suas afixações e receber o pagamento.',
    step1: { label: 'Próximas Campanhas', desc: 'Obtenha os criativos para preparar as suas afixações' },
    step2: { label: 'Verificar Afixações', desc: 'Envie prova de afixação para receber o pagamento' },
    step3: { label: 'Faturas Emitidas', desc: 'O seu histórico de faturação' },
    paidOn: 'Emitida em',
    downloadInvoice: 'Fatura',
    noPayments: 'Sem faturas emitidas',
    noPaymentsDesc: 'Conclua a etapa de verificação para desbloquear os pagamentos.',
    upcomingEmpty: 'Não tem próximas campanhas de momento. Consulte novamente mais tarde.',
    goToVerify: 'Ir para Verificação de Afixações',
    goToPaid: 'Ver Faturas',
    goToUpcoming: 'Ver Próximas Campanhas',
  },
  cart: {
    title: 'O Seu Carrinho',
    empty: 'O seu carrinho está vazio',
    emptyDesc:
      'Pesquise espaços de outdoor e adicione-os ao carrinho para criar uma campanha.',
    browseOutdoors: 'Explorar Outdoors',
    campaignDetails: 'Detalhes da Campanha',
    campaignName: 'Nome da campanha',
    description: 'Descrição (opcional)',
    subtotal: 'Subtotal',
    total: 'Total',
    remove: 'Remover',
    placeOrder: 'Criar Campanha',
    creating: 'A criar…',
    estimatedCost: 'Custo estimado',
    signInTitle: 'Inicie sessão para continuar',
    signInDesc: 'Crie uma conta ou inicie sessão para criar a sua campanha.',
    buildCampaign: 'Criar Campanha',
    estimatedTotal: 'Total estimado',
    campaignNamePlaceholder: 'Campanha Verão 2026',
    detailsPlaceholder: 'Alguma nota...',
    campaignLabel: 'Campanha {{n}}',
    selectCampaign: 'Adicionar a campanha:',
    signInToCheckout: 'Inicie sessão para criar esta campanha',
    advertiserRequired: 'Precisa de uma conta de Anunciante para criar campanhas',
    instructions: 'Instruções para os Fornecedores de Espaço (opcional)',
    instructionsPlaceholder: 'Quaisquer instruções especiais para os Fornecedores de Espaço devem ser colocadas aqui...',
    instructionsHint: 'Pode atualizar este campo após a criação da campanha.',
  },
  invitations: {
    title: 'Convites de Utilizadores',
    subtitle: 'Gerir convites de membros da equipa para a sua empresa',
    pendingTitle: 'Convites Pendentes',
    noPending: 'Sem convites pendentes',
    noPendingDesc: 'Convide um membro da equipa acima para começar.',
    sentAt: 'Enviado',
    cancel: 'Cancelar',
    inviteSuccess: 'Convite enviado com sucesso.',
    inviteError: 'Falha ao enviar convite.',
    cancelSuccess: 'Convite cancelado.',
    formTitle: 'Convidar Membro da Equipa',
    formDesc: 'Receberão um email com um link para se juntar à sua empresa na Scapow.',
    formPlaceholder: 'colega@empresa.com',
    formSend: 'Enviar Convite',
  },
  terms: {
    back: 'Voltar',
    title: 'Termos e Condições',
    effectiveDate: 'Data de eficácia: 19 de junho de 2026 · SCAPOW · Codify, Unipessoal Lda',
    introBanner: 'Ao registar uma conta, aceder ou utilizar a Plataforma, concorda em ficar legalmente vinculado por estes Termos. Se não concordar, não deve utilizar a Plataforma.',
    footerNote: 'SCAPOW · Codify, Unipessoal Lda · Vigência: 19 de junho de 2026',
    s1: 'Introdução',
    s1_p1: 'Estes Termos e Condições ("Termos") regem o acesso e a utilização da plataforma SCAPOW ("Plataforma"), operada pela Codify, Unipessoal Lda ("Empresa", "nós", "nosso", "nos").',
    s1_p2: 'A Plataforma funciona como um mercado digital que liga:',
    s1_i1Bold: 'Anunciantes',
    s1_i1Rest: ', que procuram adquirir espaços publicitários para campanhas de marketing; e',
    s1_i2Bold: 'Fornecedores de Espaço',
    s1_i2Rest: ', que possuem, operam ou controlam espaços publicitários físicos, incluindo, entre outros, outdoors, sinalizações exteriores, ecrãs digitais e outras instalações de media.',
    s2: 'Elegibilidade',
    s2_p1: 'Os utilizadores devem:',
    s2_i1: 'Ter pelo menos 18 anos;',
    s2_i2: 'Ter capacidade legal para celebrar acordos vinculativos;',
    s2_i3: 'Fornecer informações precisas e completas durante o registo;',
    s2_i4: 'Cumprir todas as leis e regulamentos aplicáveis.',
    s2_p2: 'Os utilizadores empresariais declaram que estão autorizados a vincular a sua empresa ou organização.',
    s3: 'Funções dos Utilizadores',
    s3_1: '3.1 Anunciantes',
    s3_1_p1: 'Os Anunciantes podem:',
    s3_1_i1: 'Pesquisar, selecionar e adquirir espaços publicitários;',
    s3_1_i2: 'Carregar materiais publicitários;',
    s3_1_i3: 'Lançar e gerir campanhas.',
    s3_1_p2: 'Os Anunciantes são os únicos responsáveis por:',
    s3_1_i4: 'A legalidade do seu conteúdo publicitário;',
    s3_1_i5: 'A titularidade ou autorização de toda a propriedade intelectual utilizada;',
    s3_1_i6: 'O cumprimento das leis publicitárias.',
    s3_2: '3.2 Fornecedores de Espaço',
    s3_2_p1: 'Os Fornecedores de Espaço podem:',
    s3_2_i1: 'Listar espaços publicitários disponíveis;',
    s3_2_i2: 'Definir preços, disponibilidade de campanhas e requisitos operacionais;',
    s3_2_i3: 'Aceitar colocações de campanhas.',
    s3_2_p2: 'Os Fornecedores de Espaço declaram e garantem que:',
    s3_2_i4: 'São proprietários ou controlam legalmente o espaço publicitário;',
    s3_2_i5: 'Dispõem de todas as licenças, alvarás e direitos necessários para uso publicitário comercial;',
    s3_2_i6: 'Podem cumprir as campanhas reservadas dentro dos prazos acordados.',
    s3_3: '3.3 Declaração Legal para Listagem de Espaços Publicitários',
    s3_3_p1: 'Ao listar um espaço publicitário exterior na Plataforma, cada Fornecedor de Espaço deve confirmar expressamente, no momento da submissão, que:',
    s3_3_i1: 'Detém direitos legais sobre o espaço publicitário submetido;',
    s3_3_i2: 'Está autorizado a oferecê-lo para uso comercial;',
    s3_3_i3: 'A listagem cumpre todas as leis, licenças, alvarás, regulamentos de zonamento e requisitos das autoridades locais aplicáveis.',
    s3_3_p2: 'Esta declaração é condição de listagem. As submissões sem esta confirmação não serão aceites. A Plataforma reserva o direito de remover qualquer listagem onde a declaração seja falsa ou enganosa, e de suspender ou encerrar a conta de qualquer Fornecedor de Espaço que forneça informações incorretas.',
    s4: 'Papel da Plataforma',
    s4_p1: 'A Plataforma atua exclusivamente como intermediária e facilitadora. A Empresa:',
    s4_i1: 'Não é proprietária de espaços publicitários;',
    s4_i2: 'Não atua como anunciante ou fornecedor de espaço;',
    s4_i3: 'Não garante o desempenho de campanhas, impressões ou resultados comerciais;',
    s4_i4: 'Não é responsável pela instalação ou remoção física de anúncios.',
    s4_p2: 'Cada transação estabelece uma relação contratual direta entre o Anunciante e o Fornecedor de Espaço.',
    s5: 'Reservas de Campanha',
    s5_p1: 'A reserva de uma campanha torna-se vinculativa quando:',
    s5_i1: 'O Anunciante concluiu o pagamento - pagando na íntegra ou, numa campanha paga em prestações, autorizando o primeiro pagamento e o débito direto das prestações seguintes;',
    s5_i2: 'Cada espaço publicitário está confirmado - de imediato nos espaços de reserva imediata, ou pelo respetivo Fornecedor de Espaço dentro do prazo de confirmação;',
    s5_i3: 'A data de início da campanha estiver agendada.',
    s5_p2: 'Todas as reservas estão sujeitas ao período mínimo de aviso operacional especificado pelo Fornecedor de Espaço. O período mínimo de aviso determina o momento mais tardio em que um Anunciante pode submeter e pagar uma campanha. O não cumprimento deste prazo pode resultar na recusa ou reagendamento.',
    s6: 'Condições de Pagamento',
    s6_1: '6.1 Pagamentos dos Anunciantes',
    s6_1_p1: 'Os Anunciantes pagam de acordo com o plano de pagamento escolhido no checkout:',
    s6_1_i1: 'Pagamento na íntegra - o valor total da campanha é cobrado no checkout;',
    s6_1_i2: 'Mensal ou trimestral - os custos de produção e o primeiro período de faturação são cobrados no checkout, e cada período de faturação seguinte é cobrado por débito direto no seu primeiro dia. Estes planos só estão disponíveis quando a campanha se estende para além do seu primeiro período de faturação.',
    s6_1_p2: 'O checkout deve ser concluído antes da data de início da campanha e antes de expirar o prazo de pré-aviso mínimo do Fornecedor de Espaço. Quando os espaços publicitários necessitem de confirmação, o pagamento é apenas autorizado no checkout e cobrado após a sua confirmação, e exclusivamente pelos espaços confirmados. O atraso no pagamento de qualquer prestação rege-se pela secção 6.4. Se o checkout não for concluído a tempo:',
    s6_1_i3: 'A reserva pode ser automaticamente cancelada;',
    s6_1_i4: 'O Fornecedor de Espaço não tem obrigação de reservar o espaço publicitário.',
    s6_2: '6.2 Taxas da Plataforma',
    s6_2_p1: 'A Plataforma pode cobrar taxas de serviço, comissões ou taxas de transação. Tais taxas serão divulgadas antes da compra. As taxas da Plataforma não são reembolsáveis, salvo exigência legal.',
    s6_3: '6.3 Pagamentos aos Fornecedores de Espaço',
    s6_3_p1: 'Os Fornecedores de Espaço tornam-se elegíveis para pagamento apenas após:',
    s6_3_i1: 'Os materiais publicitários estarem totalmente instalados;',
    s6_3_i2: 'A prova de instalação ter sido carregada na Plataforma;',
    s6_3_i3: 'Essa prova ser aprovada ou não contestada dentro do período de revisão aplicável.',
    s6_3_p2: 'A prova deve incluir evidência fotográfica clara mostrando a campanha corretamente exibida. A Plataforma reserva o direito de verificar a autenticidade. Os pagamentos podem ser atrasados, retidos ou revertidos em casos de fraude, disputa ou incumprimento.',
    s6_4: '6.4 Obrigações de Pagamento e Atraso no Pagamento',
    s6_4_p1: 'Cada reserva confirmada constitui uma obrigação de pagamento vinculativa do Anunciante. O Anunciante deve pagar, na íntegra e nas datas devidas, todos os montantes relativos às campanhas e espaços publicitários que reservou, incluindo cada prestação de uma campanha paga em prestações (mensal ou trimestralmente).',
    s6_4_i1: 'Qualquer montante não pago até à data de vencimento - incluindo um débito direto rejeitado, devolvido ou revertido - considera-se em atraso a partir dessa data. A Plataforma notificará o Anunciante e poderá tentar novamente a cobrança.',
    s6_4_i2: 'Quando qualquer montante relativo a uma campanha permaneça em atraso por mais de dois (2) meses a contar da data de vencimento, o Fornecedor de Espaço pode, sem qualquer responsabilidade perante o Anunciante, retirar os criativos do Anunciante dos espaços publicitários afetados e disponibilizar esses espaços a outros anunciantes.',
    s6_4_i3: 'Essa retirada não exonera o Anunciante das suas obrigações: todos os montantes já vencidos, bem como quaisquer taxas aplicáveis nos termos da secção 9.3, permanecem integralmente devidos.',
    s6_4_i4: 'A Plataforma e/ou o Fornecedor de Espaço podem recorrer às vias judiciais para cobrança de quaisquer montantes em dívida, acrescidos de juros de mora à taxa legal aplicável e dos custos razoáveis de cobrança e judiciais, na medida permitida pela lei aplicável.',
    s6_4_i5: 'A Plataforma pode ainda suspender a conta do Anunciante e recusar novas reservas até que todos os montantes em atraso sejam regularizados, nos termos da secção 15.',
    s6_4_p2: 'A retirada de criativos ao abrigo desta secção não constitui incumprimento do Fornecedor de Espaço nos termos das secções 9.4 e 9.5 e não confere direito a qualquer reembolso.',
    s7: 'Materiais de Campanha',
    s7_p1: 'Os Anunciantes devem submeter os materiais de campanha dentro do prazo exigido. Os materiais devem:',
    s7_i1: 'Cumprir as especificações técnicas;',
    s7_i2: 'Ser imprimíveis e utilizáveis;',
    s7_i3: 'Cumprir as leis aplicáveis;',
    s7_i4: 'Não conter conteúdo ilegal, difamatório, ofensivo ou que viole direitos de terceiros.',
    s7_p2: 'Os Fornecedores de Espaço podem rejeitar materiais não conformes. A Plataforma pode remover conteúdo a seu exclusivo critério.',
    s8: 'Prova de Instalação',
    s8_p1: 'Os Fornecedores de Espaço devem carregar a prova de instalação prontamente após a instalação. O não fornecimento da prova pode resultar em:',
    s8_i1: 'Atraso no pagamento;',
    s8_i2: 'Cancelamento do pagamento;',
    s8_i3: 'Suspensão da Plataforma.',
    s8_p2: 'Os Anunciantes podem contestar a prova dentro do prazo de disputa aplicável após o carregamento. Se não for apresentada contestação nesse prazo, a prova considera-se aceite.',
    s9: 'Cancelamentos e Reembolsos',
    s9_1: '9.1 Cancelamento pelo Anunciante',
    s9_1_p1: 'Se um Anunciante cancelar:',
    s9_1_i1: 'Antes do período mínimo de aviso do Fornecedor de Espaço: elegível para reembolso, deduzidas as taxas aplicáveis;',
    s9_1_i2: 'Após o início do período de aviso: o reembolso pode ser recusado.',
    s9_1_p2: 'Os custos de produção, impressão e preparação podem não ser reembolsáveis.',
    s9_2: '9.2 Cancelamento pelo Fornecedor de Espaço',
    s9_2_p1: 'Se um Fornecedor de Espaço cancelar uma reserva confirmada sem motivo válido:',
    s9_2_i1: 'O Anunciante receberá um reembolso total;',
    s9_2_i2: 'O Fornecedor de Espaço poderá incorrer em penalidades, redução de visibilidade, suspensão ou encerramento de conta.',
    s9_3: '9.3 Política de Cancelamento de Campanha',
    s9_3_i1: 'As campanhas com estado Pendente podem ser canceladas gratuitamente a qualquer momento antes do pagamento.',
    s9_3_i5: 'Quando a data de cancelamento precede a data de início de cada ativação de outdoor em mais dias do que o prazo de pré-aviso mínimo do respetivo Fornecedor de Espaço, não se aplica qualquer taxa de cancelamento e o Anunciante recebe o reembolso integral de todos os montantes pagos.',
    s9_3_i2: 'Após a conclusão do pagamento, aplica-se uma taxa de cancelamento de 30% do valor total da campanha quando uma ou mais ativações de outdoor da campanha se enquadram no prazo de pré-aviso mínimo do respetivo Fornecedor de Espaço.',
    s9_3_i3: 'Para empresas registadas em Portugal, aplica-se a taxa de IVA em vigor sobre a taxa de cancelamento.',
    s9_3_i4: 'Quando uma ou mais ativações de outdoor se enquadram no prazo de pré-aviso mínimo do Fornecedor de Espaço, os custos de instalação e impressão não são reembolsáveis.',
    s9_3_i6: 'O cancelamento de uma campanha já em execução implica a perda de 100% do valor da campanha, sem direito a reembolso.',
    s9_3_i7: 'Quando se aplica a taxa de cancelamento de 30%, 20% do valor total da campanha será transferido para os respetivos fornecedores de espaço, líquido da comissão padrão de 5% da plataforma e do IVA aplicável.',
    s9_4: '9.4 Reembolso por Outdoors Não Comprovados',
    s9_4_p1: 'No caso de um Fornecedor de Espaço não apresentar prova válida de afixação para um ou mais outdoors dentro do prazo exigido, a Scapow emitirá um reembolso ao Anunciante da seguinte forma:',
    s9_4_i1: 'Por cada dia do período da campanha em que um outdoor não exiba o criativo do Anunciante, será reembolsado ao Anunciante o valor diário proporcional desse outdoor.',
    s9_4_i4: 'Será aplicada uma taxa de cancelamento de 10% sobre o montante total reembolsado pelos dias em falha, acrescida do IVA aplicável.',
    s9_4_i2: 'Os reembolsos serão processados num prazo razoável após confirmação de que a prova de afixação não foi fornecida ou foi considerada inválida.',
    s9_4_i3: 'As taxas de serviço da plataforma aplicáveis a outdoors comprovados e cumpridos não são reembolsáveis.',
    s9_5: '9.5 Incumprimento do Fornecedor de Espaço - Execução Parcial da Campanha',
    s9_5_p1: 'Caso um Fornecedor de Espaço não exiba os materiais publicitários do Anunciante durante toda a duração acordada do período de campanha, cada dia em que a obrigação de exibição acordada não seja cumprida constituirá um "Dia de Incumprimento".',
    s9_5_a: 'a) Responsabilidade Financeira perante a Scapow',
    s9_5_p2: 'Em relação a cada Dia de Incumprimento, o Fornecedor de Espaço será responsável perante a Plataforma por um montante equivalente à taxa de valor publicitário diário aplicável ao espaço de campanha relevante (o "Montante de Incumprimento"). A recuperação do Montante de Incumprimento será efetuada a exclusivo critério da Plataforma por um ou mais dos seguintes meios:',
    s9_5_i1: '(i) exigindo que o Fornecedor de Espaço remeta o Montante de Incumprimento diretamente à Plataforma dentro do prazo especificado numa notificação escrita emitida pela Plataforma; ou',
    s9_5_i2: '(ii) deduzindo o Montante de Incumprimento de quaisquer pagamentos de campanha presentes ou futuros devidos ao Fornecedor de Espaço, seja no âmbito da mesma campanha ou de qualquer compromisso posterior na Plataforma.',
    s9_5_p3: 'A Plataforma reserva-se o direito de aplicar ambos os meios simultaneamente na medida necessária para recuperar o Montante de Incumprimento total na íntegra.',
    s9_5_b: 'b) Reembolso Integral ao Anunciante',
    s9_5_p4: 'Em relação a cada Dia de Incumprimento, o Anunciante terá direito ao reembolso integral de todos os montantes pagos por esses dias, incluindo a taxa diária de campanha correspondente, quaisquer comissões aplicáveis da Plataforma e quaisquer taxas de serviço ou transação atribuíveis a esses dias. Esse reembolso será processado pela Plataforma num prazo razoável após a confirmação do incumprimento.',
    s9_5_c: 'c) Determinação do Incumprimento',
    s9_5_p5: 'O incumprimento do período de exibição acordado será avaliado com base nas evidências submetidas através da Plataforma, incluindo, mas não se limitando a, registos de prova de colocação, relatórios de Anunciantes, documentação fotográfica e qualquer outro material que a Plataforma considere relevante. A determinação da Plataforma será final e vinculativa para efeitos do cálculo do Montante de Incumprimento e da administração dos reembolsos aos Anunciantes, sem prejuízo dos direitos legais de ambas as partes ao abrigo da legislação aplicável.',
    s9_6: '9.6 Força Maior - Catástrofes Naturais',
    s9_6_p1: 'Um "Evento de Força Maior" é uma catástrofe natural ou emergência relacionada, fora do controlo razoável do Anunciante e do Fornecedor de Espaço, que impeça fisicamente um espaço publicitário de exibir o criativo do Anunciante, ou torne essa exibição insegura - incluindo sismos, inundações, tempestades, furacões, incêndios florestais, deslizamentos de terras, ordens de evacuação ou de emergência emitidas pelas autoridades competentes e cortes de energia causados por tais eventos. Condições meteorológicas adversas comuns, o desgaste normal e a falta de manutenção não constituem Eventos de Força Maior.',
    s9_6_a: 'a) Comunicação e Prova',
    s9_6_p2: 'O Fornecedor de Espaço deve comunicar um Evento de Força Maior através da Plataforma no prazo de 48 horas após dele ter conhecimento, acompanhado de prova (como fotografias ou alertas oficiais) e de uma data estimada de reposição. A Plataforma avaliará, com base nessa prova, se o evento é elegível; a sua decisão será final e vinculativa para efeitos da presente secção.',
    s9_6_b: 'b) Efeitos para o Fornecedor de Espaço',
    s9_6_i1: 'Cada dia em que a exibição seja impedida por um Evento de Força Maior elegível (um "Dia de Força Maior") não constitui um Dia de Incumprimento nos termos da secção 9.5, não sendo devido qualquer Montante de Incumprimento relativamente ao mesmo.',
    s9_6_i2: 'Não é devido qualquer pagamento ao Fornecedor de Espaço pelos Dias de Força Maior.',
    s9_6_i3: 'O Fornecedor de Espaço deve repor a exibição no prazo de 5 dias úteis após o fim do Evento de Força Maior. Qualquer dia para além desse prazo em que a exibição não seja reposta constitui um Dia de Incumprimento nos termos da secção 9.5.',
    s9_6_i4: 'O Fornecedor de Espaço mantém a responsabilidade pela manutenção e pelo seguro adequado das suas estruturas, incluindo o custo de reimpressão e reinstalação de quaisquer materiais criativos danificados ou destruídos pelo evento.',
    s9_6_c: 'c) Efeitos para o Anunciante',
    s9_6_i5: 'O Anunciante terá direito ao reembolso integral de todos os montantes pagos pelos Dias de Força Maior, incluindo o valor diário da campanha, a comissão da Plataforma correspondente e o IVA aplicável, sem a taxa de 10% referida na secção 9.4.',
    s9_6_i6: 'Em alternativa, o Anunciante pode optar por transferir os dias afetados para o fim da campanha, sujeito à disponibilidade do espaço publicitário.',
    s9_6_i7: 'Quando um espaço publicitário fique indisponível devido a um Evento de Força Maior antes do início da sua ativação, o Anunciante ou o Fornecedor de Espaço podem removê-lo da campanha sem qualquer taxa de cancelamento, não obstante a secção 9.3, recebendo o Anunciante o reembolso integral dos montantes pagos pelo mesmo.',
    s9_6_i8: 'Quando um Evento de Força Maior dure mais de 14 dias, ou mais de metade do período restante da campanha no espaço afetado, o Anunciante pode cancelar o restante desse espaço sem custos e receber o reembolso dos dias remanescentes.',
    s9_6_i9: 'Nas campanhas pagas em prestações mensais, as prestações futuras serão reduzidas ou canceladas em conformidade.',
    s9_6_d: 'd) Âmbito',
    s9_6_p3: 'Os eventos que afetem apenas a atividade do próprio Anunciante, e não os espaços publicitários, não estão abrangidos por esta secção, aplicando-se a Política de Cancelamento de Campanhas da secção 9.3.',
    s9_7: '9.7 Vandalismo',
    s9_7_p1: '"Vandalismo" significa o dano, a desfiguração ou a remoção deliberados de um espaço publicitário ou do criativo do Anunciante por terceiros sem ligação ao Anunciante ou ao Fornecedor de Espaço - por exemplo, grafitis, cartazes rasgados ou tapados, ou ecrãs ou estruturas danificados.',
    s9_7_i1: 'O Fornecedor de Espaço deve comunicar o Vandalismo através da Plataforma no prazo de 48 horas após dele ter conhecimento, acompanhado de fotografias e, quando disponível, de uma participação policial.',
    s9_7_i2: 'O Fornecedor de Espaço deve repor a exibição no prazo de 3 dias úteis após a comunicação, a expensas próprias, incluindo a reimpressão e reinstalação do criativo.',
    s9_7_i3: 'Os dias em que a exibição seja impedida dentro desse prazo de reposição são tratados como Dias de Força Maior nos termos da secção 9.6: o Anunciante tem direito ao seu reembolso integral, sem taxas, e não é devido qualquer Montante de Incumprimento.',
    s9_7_i4: 'Os dias para além do prazo de reposição, ou o Vandalismo resultante da falta de medidas preventivas razoáveis por parte do Fornecedor de Espaço, constituem Dias de Incumprimento nos termos da secção 9.5.',
    s9_7_i5: 'Quando o mesmo espaço publicitário seja vandalizado três ou mais vezes no prazo de 30 dias, o Fornecedor de Espaço deve adotar medidas preventivas razoáveis, podendo o Anunciante cancelar o restante desse espaço sem custos e receber o reembolso dos dias remanescentes.',
    s9_7_p2: 'A comunicação de um Evento de Força Maior ou de Vandalismo que não tenha ocorrido será tratada como submissão de prova de exibição falsa nos termos da secção 12 e pode resultar na suspensão ou cessação imediata da conta.',
    proofProtectionNote: 'O seu investimento está protegido: se algum outdoor não apresentar prova verificada de afixação, a Scapow reembolsará o montante correspondente a esse outdoor.',
    s10: 'Disputas',
    s10_p1: 'Os utilizadores concordam em tentar primeiro a resolução através da Plataforma. A Plataforma pode:',
    s10_i1: 'Rever as evidências da campanha;',
    s10_i2: 'Solicitar documentação adicional;',
    s10_i3: 'Emitir uma decisão não vinculativa.',
    s10_p2: 'A decisão da Plataforma não substitui os direitos legais ao abrigo da lei aplicável.',
    s11: 'Propriedade Intelectual',
    s11_p1: 'Os Anunciantes mantêm a propriedade do conteúdo submetido.',
    s11_p2: 'Ao carregar materiais, os Anunciantes concedem à Plataforma e aos Fornecedores de Espaço uma licença limitada e não exclusiva para utilizar, reproduzir e exibir tais materiais exclusivamente para a execução da campanha.',
    s11_p3: 'Os Fornecedores de Espaço mantêm a propriedade das suas listagens, imagens e dados de localização.',
    s11_p4: 'A Plataforma mantém a propriedade de todo o software, marca e sistemas da plataforma.',
    s12: 'Uso Proibido',
    s12_p1: 'Os utilizadores não podem:',
    s12_i1: 'Cometer fraude;',
    s12_i2: 'Carregar conteúdo enganoso ou ilegal;',
    s12_i3: 'Contornar pagamentos;',
    s12_i4: 'Contactar utilizadores fora da Plataforma para evitar taxas;',
    s12_i5: 'Manipular avaliações ou resultados de campanhas;',
    s12_i6: 'Carregar prova de instalação falsa.',
    s12_p2: 'A violação pode resultar em suspensão ou encerramento imediato.',
    s13: 'Responsabilidade',
    s13_p1: 'Na máxima extensão permitida por lei, a Plataforma não será responsável por:',
    s13_i1: 'Desempenho inferior da campanha;',
    s13_i2: 'Danos causados por condições meteorológicas, catástrofes naturais e vandalismo, regulados pelas secções 9.6 e 9.7;',
    s13_i3: 'Atrasos causados por terceiros;',
    s13_i4: 'Defeitos de impressão não causados pela Plataforma;',
    s13_i5: 'Atos ou omissões dos utilizadores.',
    s13_p2: 'A responsabilidade total não excederá o total das taxas pagas à Plataforma pela campanha em causa.',
    s14: 'Indemnização',
    s14_p1: 'Os utilizadores concordam em indemnizar e isentar de responsabilidade a Empresa por quaisquer reclamações, perdas, danos, responsabilidades ou despesas decorrentes de:',
    s14_i1: 'Violação destes Termos;',
    s14_i2: 'Conteúdo publicitário ilegal;',
    s14_i3: 'Violação de direitos de terceiros;',
    s14_i4: 'Conduta fraudulenta.',
    s15: 'Suspensão de Conta',
    s15_p1: 'A Plataforma pode suspender ou encerrar contas por:',
    s15_i1: 'Fraude;',
    s15_i2: 'Falta de pagamento;',
    s15_i3: 'Disputas repetidas;',
    s15_i4: 'Abuso da Plataforma;',
    s15_i5: 'Violação destes Termos.',
    s16: 'Impostos',
    s16_p1: 'Os utilizadores são responsáveis pelos seus próprios impostos, incluindo IVA, imposto sobre vendas, imposto sobre o rendimento e quaisquer outros impostos aplicáveis. A Plataforma pode cobrar impostos quando legalmente exigido.',
    s17: 'Proteção de Dados',
    s17_p1: 'Os dados dos utilizadores serão processados de acordo com a Política de Privacidade da Plataforma e as leis de proteção de dados aplicáveis. Os utilizadores são responsáveis por garantir que têm direitos legais sobre quaisquer dados pessoais carregados.',
    s18: 'Lei Aplicável',
    s18_p1: 'Estes Termos serão regidos pelas leis aplicáveis, sem consideração de princípios de conflito de leis. As disputas ficarão sujeitas à jurisdição exclusiva dos tribunais competentes.',
    s19: 'Alterações',
    s19_p1: 'A Plataforma pode alterar estes Termos a qualquer momento. A utilização continuada da Plataforma após as alterações constitui aceitação.',
    s20: 'Contacto',
    s20_p1: 'Para questões legais:',
  },
  team: {
    title: 'Gestão da Equipa',
    subtitle: 'Gira os membros da sua equipa e envie convites',
    tabUsers: 'Membros Ativos',
    tabInvitations: 'Convites',
    noUsers: 'Ainda sem membros ativos',
    noUsersDesc: 'Os utilizadores aparecerão aqui após aceitarem o convite',
    statusVerified: 'Verificado',
    statusPending: 'Pendente',
  },
  footer: {
    tagline:
      'A plataforma que liga proprietários de espaços publicitários exteriores a anunciantes. Simples, eficiente, impactante.',
    platform: 'Plataforma',
    browseOutdoors: 'Explorar Outdoors',
    createAccount: 'Criar Conta',
    logIn: 'Entrar',
    forBusinesses: 'Para Empresas',
    registerBusiness: 'Registar Empresa',
    listOutdoors: 'Listar os seus Outdoors',
    runCampaigns: 'Lançar Campanhas',
    about: 'Sobre',
    howItWorks: 'Como Funciona',
    mission: 'A Nossa Missão',
    contactUs: 'Contacte-nos',
    copyright: '© 2026 Scapow by Codify. Todos os direitos reservados.',
    privacy: 'Privacidade',
    terms: 'Termos',
  },
  language: {
    select: 'Idioma',
    en: 'English',
    pt: 'Português',
    es: 'Español',
    de: 'Deutsch',
    zh: '中文',
    ja: '日本語',
    fr: 'Français',
    it: 'Italiano',
  },
  verification: {
    title: 'Verificação de Outdoors de Campanha',
    subtitle: 'Submeta fotos de prova para os seus outdoors de campanha ativos a aguardar verificação. Todos os outdoors de uma campanha devem ter a prova submetida para que o pagamento da campanha seja desbloqueado.',
    empty: 'Sem verificações pendentes',
    emptyDesc: 'Todos os seus outdoors de campanha ativos estão atualizados. Volte a consultar quando as suas campanhas estiverem ativas.',
    uploadProof: 'Enviar foto de prova',
    uploaded: 'Prova submetida',
    uploadSuccess: 'Foto de prova submetida com sucesso.',
    noName: 'Outdoor de Campanha',
    locating: 'A localizar…',
    awaitingVerification: 'A aguardar verificação',
    verified: 'Verificado',
    partiallyVerified: 'Parcialmente verificado',
    backToCampaigns: 'Voltar às campanhas',
    noOutdoors: 'Não foram encontrados outdoors para esta campanha',
    pendingCount: '{{count}} pendente',
    notYetAvailable: 'Verificação disponível a partir de {{date}}',
    viewProof: 'Ver foto de comprovativo',
    proofAlt: 'Foto de comprovativo',
    deleteProof: 'Eliminar comprovativo',
    deleteProofSuccess: 'Foto de comprovativo eliminada.',
    deleteProofConfirm: 'Tem a certeza que pretende eliminar esta foto de comprovativo? Esta ação não pode ser desfeita.',
  },
  howItWorksPage: {
    title: 'Como Funciona',
    subtitle: 'Seja proprietário de espaços publicitários exteriores ou pretenda alcançar novos públicos, o Scapow simplifica cada passo.',
    advertiserTab: 'Para Anunciantes',
    ppTab: 'Para Fornecedores de Espaços',
    advertiserTitle: 'Alcance o Seu Público em Grande Escala',
    advertiserSubtitle: 'Planeie, lance e acompanhe campanhas de publicidade exterior - tudo numa plataforma intuitiva.',
    adStep1Title: 'Descubra os Espaços Certos',
    adStep1Desc: 'Explore milhares de localizações exteriores verificadas num mapa interativo. Filtre por cidade, formato, dimensões, disponibilidade e tarifa diária para encontrar os locais perfeitos para a sua campanha.',
    adStep2Title: 'Construa a Sua Campanha',
    adStep2Desc: 'Selecione múltiplos outdoors e agrupe-os numa única campanha. Defina as datas, carregue o seu material criativo e confirme o plano - sem necessidade de agência.',
    adStep3Title: 'Pague com Confiança',
    adStep3Desc: 'Receba uma discriminação de pagamento transparente antes de confirmar. Pague de forma segura através da nossa plataforma e de um gateway de pagamento seguro, e receba uma fatura formal - tudo documentado e rastreável.',
    adStep4Title: 'Acompanhe Cada Colocação',
    adStep4Desc: 'Assim que a sua campanha estiver ativa, os fornecedores de espaços submetem prova fotográfica do outdoor. Monitorize o estado e as confirmações diretamente no seu painel.',
    ppTitle: 'Transforme os Seus Espaços em Receita',
    ppSubtitle: 'Liste uma vez, alcance milhares de anunciantes e ganhe ao seu próprio ritmo.',
    ppStep1Title: 'Liste os Seus Espaços',
    ppStep1Desc: 'Crie listagens detalhadas para cada um dos seus espaços exteriores. Adicione dimensões, fotos, preços e disponibilidade. Quanto mais completa a sua listagem, mais campanhas atrairá.',
    ppStep2Title: 'Seja Associado a Campanhas',
    ppStep2Desc: 'Os seus espaços surgem automaticamente nas pesquisas dos anunciantes. Quando o seu espaço for selecionado para uma campanha, recebe uma notificação e uma reserva confirmada - sem qualquer negociação.',
    ppStep3Title: 'Carregue a Prova de Exposição',
    ppStep3Desc: 'Assim que o seu outdoor estiver a exibir a campanha, carregue uma prova fotográfica através da plataforma. Esta é a sua confirmação de entrega - e desencadeia o processo de pagamento.',
    ppStep4Title: 'Receba o Pagamento',
    ppStep4Desc: 'Assim que a prova de exposição for submetida para todos os espaços de uma campanha, o pagamento é libertado de acordo com os termos acordados. Todos os seus espaços na campanha têm de ser verificados antes do processamento do pagamento - garantindo entrega completa antes da liquidação.',
    ctaTitle: 'Pronto para dar o próximo passo?',
    ctaSubtitle: 'Junte-se a milhares de empresas que já crescem com o Scapow.',
    ctaAdvertiser: 'Começar a Anunciar',
    ctaProvider: 'Listar os Meus Espaços',
  },
  brand: {
    slogan: "it's ooh good!",
  },
  missionPage: {
    title: 'A Nossa Missão',
    subtitle: 'Unir o mercado de publicidade exterior - para que cada espaço ganhe impacto e cada campanha alcance o seu público.',
    coreTitle: 'O Que Nos Move',
    coreDesc: 'A indústria de publicidade exterior está fragmentada. Excelentes espaços permanecem por explorar. As campanhas ficam aquém do seu verdadeiro potencial. Acreditamos que a tecnologia pode mudar este cenário - e o Scapow é a resposta.',
    pillar1Title: 'Amplificar Alcance e Impacto',
    pillar1Desc: 'Capacitamos os anunciantes a planear e executar campanhas exteriores de alto impacto em múltiplas localizações, a partir de uma plataforma unificada - atingindo audiências em grande escala sem complexidade operacional.',
    pillar2Title: 'Maximizar a Receita dos Fornecedores',
    pillar2Desc: 'Damos aos fornecedores de espaços acesso direto a um conjunto qualificado de procura publicitária, reduzindo o inventário por preencher e garantindo que os seus espaços geram receita consistente e previsível.',
    pillar3Title: 'Ligar o Mercado OOH Estático',
    pillar3Desc: 'Estamos a construir a infraestrutura que a indústria exterior há muito precisava - um mercado transparente e digital-first onde a oferta encontra a procura de forma eficiente, justa e à escala.',
    pillar4Title: 'Confiança Através da Transparência',
    pillar4Desc: 'Da verificação de credenciais empresariais à prova fotográfica de exposição, cada etapa do processo Scapow é projetada para ser auditável, responsável e baseada na confiança mútua entre todas as partes.',
    visionTitle: 'A Nossa Visão',
    visionDesc: 'Um mundo onde cada espaço exterior é uma oportunidade - e cada marca pode encontrar a sua tela perfeita, onde quer que o seu público viva, trabalhe e se mova.',
    closingTitle: 'Construindo o Futuro do OOH',
    closingDesc: 'O Scapow é mais do que um mercado. É o tecido conjuntivo da indústria de publicidade exterior - reunindo fornecedores de espaços, anunciantes e a tecnologia que impulsiona o seu sucesso partilhado.',
  },
  contact: {
    label: 'Entre em Contacto',
    title: 'Contacte-nos',
    subtitle: 'Tem uma pergunta, feedback ou simplesmente quer dizer olá? Adoraríamos ouvir de si.',
    infoTitle: 'Vamos Conversar',
    infoDesc: 'Seja sobre funcionalidades, preços ou qualquer outra coisa - a nossa equipa está pronta para responder a todas as suas perguntas.',
    responseTimeTitle: 'Resposta Rápida',
    responseTimeDesc: 'Normalmente respondemos dentro de 24 horas.',
    emailTitle: 'Envie-nos um Email',
    whatsappTitle: 'WhatsApp',
    formTitle: 'Envie-nos uma mensagem',
    fieldName: 'O seu Nome',
    fieldEmail: 'O seu Email',
    fieldSubject: 'Assunto',
    fieldMessage: 'Mensagem',
    namePlaceholder: 'João Silva',
    emailPlaceholder: 'voce@exemplo.com',
    subjectPlaceholder: 'Como podemos ajudar?',
    messagePlaceholder: 'Diga-nos o que tem em mente…',
    submit: 'Enviar Mensagem',
    submitting: 'A enviar…',
    successTitle: 'Mensagem enviada!',
    successDesc: 'Obrigado por nos contactar. Entraremos em contacto em breve.',
    backHome: 'Voltar ao Início',
    errorRequired: 'Este campo é obrigatório.',
    errorEmail: 'Por favor insira um endereço de email válido.',
  },
  calendar: {
    calendarMonthsHint: 'Reservado por meses de calendário completos, do dia 1 ao último dia. Clique num dia 1 para começar, num dia posterior para adicionar o seu mês, ou num dia dentro da reserva para a encurtar.',
    startOnMonthFirstHint: 'As reservas começam no dia 1 de um mês.',
    fullMonthHint: 'Reserva ao mês: escolha o dia de início e clique num dia posterior para adicionar meses - cada um termina no mesmo dia do mês seguinte (começando num dia 1, no último dia do mês). Clique dentro da reserva para a encurtar.',
    discountsTitle: 'Reserve mais tempo, poupe mais',
    discountTier: '{{days}}+ dias',
    discountsPickStart: 'Escolha uma data de início para ver que datas de fim têm desconto.',
    discountsHighlighted: 'Quanto mais escuro o verde, maior o desconto - as etiquetas mostram onde cada um começa.',
    discountApplied: '{{percentage}}% de desconto nestes {{count}} dias',
    discountNextTier: 'Adicione mais {{days}} dia(s) para poupar {{percentage}}%',
    latestStartInfo: 'Datas de início até {{date}}',
    blockedLegend: 'Bloqueado / indisponível',
    pendingLegend: 'Pendente (ainda não guardado)',
    loading: 'A carregar disponibilidade…',
    noticeRequired: 'Data de início mais cedo: {{date}} (aviso prévio de {{count}} dias necessário)',
    minimumDaysError: 'Aluguer mínimo de {{count}} dias - por favor alargue a sua seleção',
    overlapError: 'O intervalo selecionado inclui datas reservadas - escolha apenas dias consecutivos disponíveis',
  },
  approvals: {
    thisBookingLegend: 'Esta reserva',
    blockedSelection: 'Período bloqueado:',
    blockedSelectionEmpty: 'Escolha as datas de início e fim no calendário.',
    title: 'Aprovações',
    subtitle: 'Confirme se os seus outdoors estão disponíveis para estas campanhas pagas.',
    emptyTitle: 'Está tudo em dia',
    emptyDesc: 'Quando um anunciante reservar um dos seus outdoors, irá aparecer aqui para aprovação.',
    campaignFallback: 'Campanha',
    outdoorsToReview: 'Outdoors a rever: {{count}}',
    startsOn: 'Começa a {{date}}',
    answerBy: 'Responder até {{date}}',
    review: 'Rever',
    youEarn: 'Recebe',
    backToList: 'Voltar às aprovações',
    reviewEyebrow: 'Pedido de aprovação',
    summaryLine: 'Outdoors: {{count}} · Recebe {{value}}',
    deadlineNotice: 'Responda até {{date}}. Os outdoors sem resposta a tempo são removidos da campanha.',
    progress: '{{answered}} de {{total}} respondidos',
    approveAll: 'Aprovar todos',
    available: 'Disponível',
    unavailable: 'Indisponível',
    decisionFor: '{{name}} está disponível?',
    decisionRequired: 'Escolha uma resposta.',
    blockedHint: 'Indique quando este outdoor já está ocupado - vamos bloquear estas datas.',
    blockedFrom: 'Bloqueado de',
    blockedTo: 'Bloqueado até',
    blockedRequired: 'As duas datas são obrigatórias.',
    blockedOrder: 'A data de fim tem de ser igual ou posterior à de início.',
    viewCreative: 'Ver o criativo de {{name}}',
    noCreative: 'Ainda sem criativo',
    feedbackMandatory: 'É necessária uma resposta para cada outdoor.',
    submit: 'Enviar respostas',
    fixBeforeSubmit: 'Responda a todos os outdoors e verifique as datas bloqueadas.',
    confirmTitle: 'Enviar as suas respostas?',
    confirmSummary: 'Disponíveis: {{approved}} · Indisponíveis: {{unavailable}}',
    confirmNote: 'As respostas não podem ser alteradas depois de enviadas.',
    submitted: 'Obrigado - as suas respostas foram enviadas.',
    submitError: 'Não foi possível enviar as suas respostas.',
    allAnsweredTitle: 'Já respondido',
    allAnsweredDesc: 'Já respondeu por todos os seus outdoors nesta campanha.',
    loadErrorTitle: 'Esta aprovação não está disponível',
    loadErrorDesc: 'Pode já ter sido respondida, ou a campanha foi cancelada.',
  },
  status: {
    installment: {
      SCHEDULED: 'Agendada',
      PROCESSING: 'Em processamento',
      PAID: 'Paga',
      FAILED: 'Falhada',
      CANCELLED: 'Cancelada',
    },
    campaign: {
      PENDING: 'Rascunho',
      AWAITING_PAYMENT: 'A aguardar pagamento',
      CONFIRMING: 'A aguardar fornecedores',
      AWAITING_CONFIRMATION: 'Decisão necessária',
      READY: 'Confirmada',
      RUNNING: 'Em exibição',
      COMPLETED: 'Concluída',
      CANCELLED: 'Cancelada',
      UNAVAILABLE: 'Indisponível',
    },
    payment: {
      PENDING: 'Por pagar',
      VALIDATING_PAYMENT: 'A validar pagamento',
      MANUAL_VALIDATION: 'Em revisão',
      TRANSFER_REQUESTED: 'Transferência pedida',
      PAID: 'Pago',
      CANCELLED: 'Cancelado',
      PARTIALLY_REFUNDED: 'Parcialmente reembolsado',
      FULLY_REFUNDED: 'Reembolsado',
      FAILED: 'Falhou',
    },
    campaignOutdoor: {
      PENDING: 'A aguardar prova',
      VERIFYING: 'A verificar prova',
      FOR_MANUAL_APPROVAL: 'Prova em revisão',
      APPROVED: 'Prova aprovada',
      REJECTED: 'Prova rejeitada',
      REFUNDED: 'Reembolsado',
      CANCELLED: 'Cancelado',
    },
    proof: {
      PENDING: 'Pendente',
      VALID: 'Válida',
      MANUAL_VALIDATION: 'Em revisão',
      INVALID: 'Inválida',
    },
    paymentType: {
      BUYING_ADS: 'Compra de publicidade',
      SELLING_ADS: 'Pagamento ao fornecedor',
      REFUND_BUYING_PART: 'Reembolso ao anunciante',
      REFUND_SELLING_PART: 'Reembolso do fornecedor',
      PLACEMENT_PROVIDER_DEBT: 'Dívida do fornecedor',
      PLACEMENT_PROVIDER_CANCELLATION_FEE: 'Compensação por cancelamento',
    },
  },
  offlineCampaigns: {
    creativesTitle: 'Criativos',
    creativesSubtitle: 'Artes a instalar. Qualquer dimensão serve - decide como se ajusta a cada outdoor.',
    uploadCreatives: 'Carregar criativos',
    noCreatives: 'Ainda não há criativos. Clique para carregar ficheiros JPG, PNG, TIFF ou PDF.',
    creativesUploaded: 'Criativos carregados.',
    creativeRemoved: 'Criativo removido.',
    removeCreative: 'Remover criativo',
    removeCreativeConfirm: 'Remover este criativo? Esta ação não pode ser desfeita.',
    downloadOriginal: 'Descarregar original',
    filesTitle: 'Ficheiros',
    filesSubtitle: 'Contratos, briefings ou qualquer outro ficheiro desta campanha.',
    uploadFiles: 'Carregar ficheiros',
    noFiles: 'Ainda não há ficheiros carregados.',
    filesUploaded: 'Ficheiros carregados.',
    fileRemoved: 'Ficheiro removido.',
    removeFile: 'Remover ficheiro',
    removeFileConfirm: 'Remover “{{name}}”? Esta ação não pode ser desfeita.',
    download: 'Descarregar',
    remove: 'Remover',
    outdoorsTitle: 'Outdoors',
    noOutdoors: 'Esta campanha ainda não tem outdoors.',
    modalTitle: 'Adicionar a uma campanha offline',
    newTitle: 'Nova campanha offline',
    pickTitle: 'Escolher uma campanha offline',
    datesTitle: 'Escolha as datas',
    doneTitle: 'Outdoor adicionado',
    forOutdoor: 'Outdoor:',
    optionNew: 'Nova',
    optionNewDesc: 'Crie uma campanha para uma reserva vendida fora da Scapow.',
    optionPick: 'Escolher existente',
    optionPickDesc: 'Adicione-o a uma das suas campanhas offline.',
    name: 'Nome da campanha',
    nameRequired: 'Dê um nome à campanha.',
    details: 'Detalhes',
    detailsHint: 'Ex.: o cliente ou o canal em que foi vendida.',
    notes: 'Notas',
    notesHint: 'Notas internas - visíveis apenas para a sua equipa.',
    instructions: 'Instruções',
    instructionsHint: 'Para quem instala o criativo.',
    createAndContinue: 'Criar e continuar',
    createError: 'Não foi possível criar a campanha offline.',
    addError: 'Não foi possível adicionar o outdoor à campanha.',
    noneYet: 'Ainda não tem campanhas offline.',
    outdoorsCount: 'Outdoors: {{count}}',
    createdOn: 'criada a {{date}}',
    datesIntro: 'Escolha quando o outdoor está reservado para “{{campaign}}”. As datas já ocupadas são mostradas e não podem ser selecionadas.',
    pickDates: 'Escolha as datas de início e fim no calendário.',
    addToCampaign: 'Adicionar à campanha',
    doneMessage: '{{outdoor}} foi adicionado a “{{campaign}}”.',
    doneHint: 'Estas datas estão agora bloqueadas para outras reservas.',
    backToSearch: 'Voltar à pesquisa',
    getAvailability: 'Ver disponibilidade',
    clearAvailability: 'Limpar disponibilidade',
    availabilityTitle: 'Ver disponibilidade',
    availabilityHint: 'Escolha uma data de início e de fim para ver apenas os outdoors livres durante todo o período.',
    showAvailable: 'Mostrar outdoors disponíveis',
    dimensionsLabel: 'Dimensões',
    noMatches: 'Nenhum outdoor corresponde a estes filtros',
    noMatchesHint: 'Experimente outras dimensões ou datas, ou limpe os filtros.',
    clearFilters: 'Limpar filtros',
    addButton: 'Adicionar a campanha offline',
    addTooltip: 'Adicionar a uma campanha não reservada através da Scapow',
  },
};

export default pt;
